<template>
  <el-container class="tyc_order">
    <el-header class="header-style">
      <el-row style="margin: 0 0 0.2rem 0">
        <el-col :span="6">
          <el-input v-model="searchArr.orderNum" size="mini" clearable placeholder="关键词:公司名称、订单号、手机号、客户姓名"
            @input="handleOrderNumChange">
          </el-input>
        </el-col>
        <el-col :span="4" style="padding-right: 0; margin-left: 0.2rem">
          <el-select v-model="selectedColumns" multiple filterable collapse-tags size="mini" placeholder="请选择自定义固定列"
            :popper-append-to-body="false" @change="handleColumnSelectionChange">
            <el-option v-for="field in fields" :key="field.id" :label="field.name" :value="field.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10" class="tr" style="float: right">
          <el-button type="primary" size="mini" @click="handleAddOpen"
            v-if="pageNodes.indexOf('录入') !== -1">录入</el-button>
          <el-tooltip effect="dark" content="批量分配人员" placement="top">
            <el-button type="warning" size="mini" @click="hugeAssign" style="margin-left: 0 !important">批量分配</el-button>
          </el-tooltip>
          <el-tooltip effect="dark" content="批量关联公司业务员为订单沟通顾问" placement="top">
            <el-button type="primary" size="mini" @click="handleUpdateComSaler"
              style="margin-left: 0 !important">批量替换公司业务员</el-button>
          </el-tooltip>
          <!-- <el-upload style="display:inline-block" :action="actionHost + '/api/tycorder/import_sharer'"
            :headers="headers" :show-file-list="false" :on-success="handleImportSharer">
            <el-button style="margin-left: 0 !important;" type="success" size="mini">批量导入共享人</el-button>
          </el-upload> -->
          <el-popover placement="bottom" width="10" trigger="click">
            <div style="
                display: flex;
                justify-content: space-between;
                flex-direction: column;
              ">
              <el-upload v-if="false" :action="actionHost + '/api/admin/tyc_order/import'" :headers="uploadHeader"
                :show-file-list="false" :on-success="handleImport">
                <el-button type="primary" size="mini">导入</el-button>
              </el-upload>
              <el-popover placement="right" width="400" trigger="click" @hide="clearCompanyRowCol">
                <div>
                  <div :class=$style.expSelContainer>
                    <el-select size="mini" :class="$style.selectItem" v-model="rowSelected" clearable
                      placeholder="请选择公司名称所在行">
                      <el-option v-for="item in 8" :key="item" :label="item" :value="item">
                      </el-option>
                    </el-select>
                    <el-select size="mini" :class="$style.selectItem" v-model="colSelected" clearable
                      placeholder="请选择公司名称所在列">
                      <el-option v-for="item in 16" :key="item" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </div>
                  <el-upload :class="$style.upStyle" action="" :headers="uploadHeader" :show-file-list="false"
                    :http-request="doInvoiceExport" :before-upload="beforeExpUpload" accept=".xlsx,.csv">
                      <el-button type="primary" size="mini">选择文件</el-button>
                  </el-upload>
                </div>
                <el-button style="margin-left: 0.2rem; width: 140px;" type="primary" size="mini"
                  slot="reference">导出（对账单）</el-button>
              </el-popover>
              <el-button style="margin-top: 0.1rem; width: 140px; margin-left: 0.2rem" type="primary" size="mini"
                @click="handleExportFlash">导出订单</el-button>
              <el-button style="margin-top: 0.1rem; width: 140px; margin-left: 0.2rem"
                v-if="pageNodes.indexOf('导出') !== -1" type="info" size="mini" @click="handleExport">导出订单</el-button>
              <el-button style="margin-top: 0.1rem" type="danger" size="mini"
                @click="handleExportDetail">导出订单详情</el-button>
              <el-button style="margin-top: 0.1rem" type="primary" size="mini"
                @click="alipayOrderSync">支付宝推广订单同步</el-button>
              <el-button style="margin-top: 0.1rem" v-if="pageNodes.indexOf('导出来源') !== -1" type="info" size="mini"
                @click="handleSourcesExport">导出来源</el-button>
              <el-button style="margin-top: 0.1rem" v-if="pageNodes.indexOf('导出服务进度') !== -1" type="info" size="mini"
                @click="handleScheduleExport">导出进度</el-button>
              <el-button style="margin-top: 0.1rem" type="info" size="mini" @click="handleRecord">我的战绩</el-button>
              <el-button type="primary" style="margin-top: 0.1rem" size="mini"
                @click="updatePhoneFrom">更新手机归属地</el-button>
            </div>
            <el-button type="primary" size="mini" slot="reference">更多操作</el-button>
          </el-popover>
        </el-col>
      </el-row>
      <el-collapse accordion v-model="activeOpen">
        <el-collapse-item name="1">
          <template slot="title">
            高级筛选<i class="header-icon el-icon-info"></i>
          </template>
          <el-card shadow="always" style="margin-bottom: 0.2rem">
            <el-row style="margin: 0.05rem 0 0.2rem 0">
              <el-col :span="2">派单时间</el-col>
              <el-col :span="4">
                <el-date-picker size="mini" v-model="searchArr.orderDate" type="daterange" align="right" unlink-panels
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                  :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-col>
              <el-col :span="2" :offset="1">订单状态</el-col>
              <el-col :span="3">
                <el-select v-model="searchArr.order_status" placeholder="请选择" size="mini" clearable>
                  <el-option :value="1" label="已付款"></el-option>
                  <el-option :value="2" label="申请退款中"></el-option>
                  <el-option :value="3" label="已退款"></el-option>
                  <el-option :value="4" label="拒绝退款"></el-option>
                  <el-option :value="5" label="系统结单"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="1">沟通状态</el-col>
              <el-col :span="3">
                <el-select v-model="searchArr.chat_status" placeholder="请选择" size="mini" clearable>
                  <el-option :value="1" label="未分配"></el-option>
                  <el-option :value="2" label="待沟通"></el-option>
                  <el-option :value="3" label="沟通中"></el-option>
                  <el-option :value="4" label="联系不到"></el-option>
                  <el-option :value="5" label="已失联"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="1">服务状态</el-col>
              <el-col :span="3">
                <el-select v-model="searchArr.service_status" placeholder="请选择" size="mini" clearable>
                  <el-option :value="1" label="未分配"></el-option>
                  <el-option :value="2" label="待服务"></el-option>
                  <el-option :value="3" label="服务中"></el-option>
                  <el-option :value="4" label="服务完成"></el-option>
                  <el-option :value="5" label="服务暂停"></el-option>
                  <el-option :value="6" label="服务停止"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row style="margin: 0.05rem 0 0.2rem 0">
              <el-col :span="2">订单类型</el-col>
              <el-col :span="4">
                <el-cascader style="width: 100%" v-model="searchArr.orderRegType" placeholder="请选择" :options="orderRegs"
                  size="mini" :props="{ expandTrigger: 'hover', multiple: true }" clearable filterable
                  :filter-method="filterOptions" collapse-tags>
                </el-cascader>
              </el-col>
              <el-col :span="2" :offset="1">分配时间</el-col>
              <el-col :span="3">
                <el-date-picker size="mini" v-model="searchArr.assign_chater_time" type="daterange" align="right"
                  unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                  :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-col>
              <!-- <template v-if="searchArr.orderRegType.includes(5)">
                <el-col :span="2" :offset="1">单品类型</el-col>
                <el-col :span="3">
                  <el-select
                    v-model="searchArr.mealSingles"
                    multiple
                    filterable
                    placeholder="请选择"
                    size="mini"
                    clearable
                  >
                    <el-option
                      v-for="mealSingle in mealSingles"
                      :key="mealSingle.item_id"
                      :label="mealSingle.item_name"
                      :value="mealSingle.item_id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </template> -->
              <el-col :span="2" :offset="1">收款方式</el-col>
              <el-col :span="3">
                <el-cascader ref="cascaderInput" style="width: 100%" v-model="searchArr.moneyin" placeholder="请选择"
                  :options="moneyInCateOptions" size="mini"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }" clearable filterable
                  @visible-change="handleVisibleChange($event, 'money_in')" :filter-method="filterOptions">
                </el-cascader>
              </el-col>
              <el-col :span="2" :offset="1">续费订单</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.is_renew" size="mini">
                  <el-radio-button label="1">是</el-radio-button>
                  <el-radio-button label="0">否</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin: 0.05rem 0 0.2rem 0">
              <el-col :span="2">订单来源</el-col>
              <el-col :span="4">
                <el-cascader ref="cascaderOrderFromInput" v-model="searchArr.platform" placeholder="请选择"
                  :options="fromOptions" :size="inputSize"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }" clearable filterable
                  @visible-change="handleVisibleChange($event, 'order_from')" :filter-method="filterOptions">
                </el-cascader>
              </el-col>
              <el-col :span="2" :offset="1">客户来源</el-col>
              <el-col :span="3">
                <el-cascader ref="cascaderCustomerSourceInput" v-model="searchArr.sources" placeholder="请选择"
                  :options="sources" :size="inputSize"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }" clearable filterable
                  @visible-change="handleVisibleChange($event, 'customer_source')" :filter-method="filterOptions">
                </el-cascader>
              </el-col>
              <el-col :span="2" :offset="1">落地园区</el-col>
              <el-col :span="3">
                <el-select v-model="searchArr.order_park" placeholder="请选择" :size="inputSize" filterable clearable>
                  <el-option v-for="option in place_parks" :key="option.id" :label="option.name"
                    :value="option.id"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="1">老客户注销订单</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.is_old_cus_out" size="mini">
                  <el-radio-button label="1">是</el-radio-button>
                  <el-radio-button label="0">否</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <!-- <el-row style="margin: 0.05rem 0 0.2rem 0">

            </el-row> -->
            <el-row>
              <el-checkbox v-model="checkedCustomer" @change="checkedCustomerState">客户沟通情况</el-checkbox>
              <el-checkbox v-model="checkedOrder" @change="checkedOrderState">订单关联人员</el-checkbox>
              <el-checkbox v-model="checkedOthers" @change="checkedOthersState">订单对账情况</el-checkbox>
              <el-checkbox v-model="checkedRefund" @change="checkedRefundState">退款结单情况</el-checkbox>
            </el-row>
          </el-card>
          <el-card shadow="always" style="margin-bottom: 0.2rem" v-if="checkedCustomer === true">
            <el-row style="margin: 0.05rem 0 0.2rem 0">
              <el-col :span="2">联系时间</el-col>
              <el-col :span="7">
                <el-date-picker size="mini" v-model="searchArr.contact_time" type="datetimerange"
                  :picker-options="contactPicker" align="right" unlink-panels range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
              </el-col>
              <el-col :span="2" :offset="1">联系超时</el-col>
              <el-col :span="3">
                <el-select v-model="searchArr.timeOut" placeholder="请选择" size="mini" clearable>
                  <el-option :value="2" label="超过3天"></el-option>
                  <el-option :value="3" label="超过5天"></el-option>
                  <el-option :value="4" label="超过7天"></el-option>
                  <el-option :value="5" label="超过15天"></el-option>
                  <el-option :value="6" label="超过30天"></el-option>
                  <el-option :value="1" label="未联系"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="1">客户意向</el-col>
              <el-col :span="3">
                <el-select v-model="searchArr.intention" placeholder="请选择" size="mini" clearable>
                  <el-option :value="1" label="A"></el-option>
                  <el-option :value="2" label="B"></el-option>
                  <el-option :value="3" label="C"></el-option>
                  <el-option :value="4" label="D"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row style="margin: 0.05rem 0 0.2rem 0">
              <el-col :span="2">号码归属地</el-col>
              <el-col :span="3">
                <el-select size="mini" v-model="searchArr.pro" placeholder="请输入省份" remote reserve-keyword clearable
                  filterable :remote-method="remoteGetProvince" :loading="loading">
                  <el-option v-for="(item, index) in searchSingleProvince" :key="index" :label="item.province"
                    :value="item.province">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="3" style="margin-left: 0.2rem">
                <el-select size="mini" v-model="searchArr.city" placeholder="请输入城市" remote reserve-keyword clearable
                  filterable :remote-method="remoteGetCity" :loading="loading">
                  <el-option v-for="(item, index) in searchSingleCity" :key="index" :label="item.city"
                    :value="item.city">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="1" :offset="1">工单</el-col>
              <el-col :span="5">
                <el-radio-group v-model="searchArr.workOrder" size="mini">
                  <el-radio-button label="1">待处理</el-radio-button>
                  <el-radio-button label="2">已处理</el-radio-button>
                  <el-radio-button label="3">已超时</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="3">是否绑定企业微信群</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.is_bind_we_group" size="mini">
                  <el-radio-button label="1">是</el-radio-button>
                  <el-radio-button label="0">否</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin: 0.05rem 0 0.2rem 0">
              <el-col :span="2">通话状态</el-col>
              <el-col :span="3">
                <el-select v-model="searchArr.UlFailReason" filterable placeholder="请选择" clearable multiple size="mini">
                  <el-option value="HangUp" label="正常挂机"></el-option>
                  <el-option value="CallerBusy" label="主叫用户忙"></el-option>
                  <el-option value="CallerNoAnswer" label="主叫无应答"></el-option>
                  <el-option value="CallerFailure" label="主叫其它原因失败"></el-option>
                  <el-option value="CallerAbandon" label="呼叫被叫过程中主叫挂机"></el-option>
                  <el-option value="CalleeBusy" label="被叫忙"></el-option>
                  <el-option value="CalleeNoAnswer" label="被叫无应答"></el-option>
                  <el-option value="CalleeFailure" label="被叫其它原因失败"></el-option>
                  <el-option value="Other" label="其它原因失败"></el-option>
                </el-select>
              </el-col>
              <el-col :span="3" :offset="1">需再次沟通订单</el-col>
              <el-col :span="7">
                <el-date-picker size="mini" v-model="searchArr.next_contact_time" type="datetimerange"
                  :picker-options="nextContactPicker" align="right" unlink-panels range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
              </el-col>
              <el-col :span="2" :offset="1">客户隶属</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.customer_belongs" size="mini">
                  <el-radio-button v-for="item in customerBelongs" :label="item.id" :key="item.id">
                    {{ item.name }}
                  </el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2">领取执照时间</el-col>
              <el-col :span="7">
                <el-date-picker size="mini" v-model="searchArr.license_at" type="datetimerange"
                  :picker-options="licensePicker" align="right" unlink-panels range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
              </el-col>
              <el-col :span="2" :offset="1">公司成立时间</el-col>
              <el-col :span="7">
                <el-date-picker size="mini" v-model="searchArr.established_at" type="datetimerange" align="right"
                  unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                  :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
              </el-col>
            </el-row>
          </el-card>
          <el-card shadow="always" style="margin-bottom: 0.2rem" v-if="checkedOrder === true">
            <el-row style="margin: 0.05rem 0 0.2rem 0">
              <el-col :span="2">沟通专员</el-col>
              <el-col :span="4">
                <el-cascader v-model="searchArr.consultant" placeholder="请选择沟通专员" :options="personnel" size="mini"
                  :props="{ expandTrigger: 'hover' }" clearable filterable :filter-method="filterOptions">
                </el-cascader>
              </el-col>
              <el-col :span="2" :offset="1">服务专员</el-col>
              <el-col :span="3">
                <el-cascader v-model="searchArr.operator" placeholder="请选择服务专员" :options="personnel" size="mini"
                  :props="{ expandTrigger: 'hover' }" clearable filterable :filter-method="filterOptions">
                </el-cascader>
              </el-col>
              <el-col :span="2" :offset="1">转化人员</el-col>
              <el-col :span="3">
                <el-cascader v-model="searchArr.convert" placeholder="请选择转化人员" :options="personnelConvert" size="mini"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }" clearable filterable
                  :filter-method="filterOptions">
                </el-cascader>
              </el-col>
              <el-col :span="2" :offset="1">共享人</el-col>
              <el-col :span="3">
                <el-cascader v-model="searchArr.sharer" placeholder="试试搜索：共享人" :options="personnel"
                  :props="{ multiple: true, expandTrigger: 'hover' }" size="mini" clearable filterable
                  :filter-method="filterOptions">
                </el-cascader>
              </el-col>
            </el-row>
          </el-card>
          <el-card shadow="always" style="margin-bottom: 0.2rem" v-if="checkedOthers === true">
            <el-row style="margin: 0.05rem 0 0.2rem 0">
              <el-col :span="2">是否会员</el-col>
              <el-col :span="4">
                <el-radio-group v-model="searchArr.is_member" size="mini">
                  <el-radio-button label="y">是</el-radio-button>
                  <el-radio-button label="n">否</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" :offset="1">是否对账</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.is_check_account" size="mini">
                  <el-radio-button label="y">是</el-radio-button>
                  <el-radio-button label="n">否</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" :offset="1">是否关联发票</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.is_open_ticket" size="mini">
                  <el-radio-button label="y">是</el-radio-button>
                  <el-radio-button label="n">否</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" :offset="1">订单暂未开票</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.not_invoiced" size="mini">
                  <el-radio-button label="y">是</el-radio-button>
                  <el-radio-button label="n">否</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin: 0.05rem 0 0.2rem 0">
              <el-col :span="2">是否绑定公司</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.is_bind_company" size="mini">
                  <el-radio-button label="y">是</el-radio-button>
                  <el-radio-button label="n">否</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" :offset="2">是否绑定客户</el-col>
              <el-col :span="4">
                <el-radio-group v-model="searchArr.is_bind_client" size="mini">
                  <el-radio-button label="y">是</el-radio-button>
                  <el-radio-button label="n">否</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2">是否签署合同</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.is_sign_contract" size="mini">
                  <el-radio-button label="y">是</el-radio-button>
                  <el-radio-button label="n">否</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-card>
          <el-card shadow="always" style="margin-bottom: 0.2rem" v-if="checkedRefund === true">
            <el-row style="margin: 0.05rem 0 0.2rem 0">
              <el-col :span="2">退款原因</el-col>
              <el-col :span="4">
                <el-select v-model="searchArr.reason_for_return" size="mini" placeholder="请选择" clearable>
                  <el-option v-for="cause in causes" :key="cause.refund_id" :label="cause.refund_cause"
                    :value="cause.refund_id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="1">退款申请时间</el-col>
              <el-col :span="4">
                <el-date-picker size="mini" v-model="searchArr.refund_date" type="daterange"
                  :picker-options="refundPicker" align="right" unlink-panels clearable range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-col>
            </el-row>
          </el-card>
          <el-row style="text-align: center">
            <el-col>
              <el-button type="primary" size="mini" @click="handleASearSub">查询</el-button>
              <el-button type="danger" size="mini" @click="handleASearClear">清除</el-button>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-header>

    <el-main class="main-style">
      <el-table height="calc(100vh - 266px)" v-if="!loading" v-cloak :data="pageData" border size="medium"
        style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" fixed></el-table-column>
        <el-table-column fixed label="订单编号" width="330">
          <template slot-scope="scope">
            <i v-if="scope.row.work_orders_count" class="el-icon-warning"></i>
            <el-link type="primary" @click="handleOrderInfo(scope.row.id, scope.row.order_num)">{{ scope.row.order_num
              }}
            </el-link>
            <i class="el-icon-tickets" style="cursor: pointer" @click="copyUrl(scope.row.order_num)"></i>
            <el-row>
              <el-tooltip v-if="scope.row.is_member && scope.row.customer_name != null" class="item" effect="dark"
                :content="scope.row.customer_name != null ? scope.row.customer_name : '未知'
                  " placement="top">
                <el-button @click="
                  openMemberInfoDrawer(
                    scope.row.vagary_phone_custome
                      ? scope.row.vagary_phone_custome
                      : scope.row.customer_phone
                  )
                  " type="success" size="mini" icon="el-icon-user" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip v-else class="item" effect="dark" content="未关联客户" placement="top">
                <el-button type="info" size="mini" icon="el-icon-user" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip v-if="scope.row.company === null" class="item" effect="dark" content="未绑定公司" placement="top">
                <el-button @click="handBindCompanyOpen(scope.row.id)" type="info" size="mini"
                  icon="el-icon-office-building" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip v-else class="item" effect="dark"
                :content="scope.row.company_obj ? scope.row.company_obj.company_name : ''" placement="top">
                <el-button @click="handCompanyOpen(scope.row.company_obj.id)" type="success" size="mini"
                  icon="el-icon-office-building" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip v-if="scope.row.acc_discharge_no === null" class="item" effect="dark" content="未关联流水号"
                placement="top">
                <el-button @click="handBindTaxNumberOpen(scope.row)" type="info" size="mini" icon="el-icon-bank-card"
                  style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip v-else class="item" effect="dark" content="已关联流水号" placement="top">
                <el-button @click="handLookFlowRecord(scope.row.acc_discharge_no)" type="success" size="mini"
                  icon="el-icon-bank-card" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip v-if="scope.row.contract === null" class="item" effect="dark" content="未关联合同" placement="top">
                <el-button type="info" size="mini" icon="el-icon-coordinate" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip v-else class="item" effect="dark" content="已关联合同" placement="top">
                <el-button @click="handLookContractOpen(scope.row.contract.id)" type="success" size="mini"
                  icon="el-icon-coordinate" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <!-- <el-tooltip v-if="scope.row.invoice_no === null" class="item" effect="dark" content="未关联发票号" -->
              <el-tooltip v-if="scope.row.not_invoiced == 1" class="item" effect="dark" content="暂未开发票" placement="top">
                <el-button @click="
                  handInvoiceNoOpen(scope.row, scope.row.id, scope.row.company, 1)
                  " type="warning" size="mini" icon="el-icon-printer" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip v-else-if="!scope.row.invoice_no" class="item" effect="dark" content="未关联发票号" placement="top">
                <el-button @click="
                  handInvoiceNoOpen(scope.row, scope.row.id, scope.row.company, 1)
                  " type="info" size="mini" icon="el-icon-printer" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip v-else class="item" effect="dark" content="已关联发票号" placement="top">
                <el-button @click="
                  handInvoiceNoOpen(scope.row, scope.row.id, scope.row.company, 2)
                  " type="success" size="mini" icon="el-icon-printer" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="云上公司注册微信小程序推广订单" placement="top"
                v-if="scope.row.is_ccwc_tg === true">
                <div style="
                    display: inline-block;
                    border-radius: 100%;
                    background-color: #f56c6c;
                    color: white;
                    width: 20px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    margin-left: 0.2rem;
                  ">
                  推
                </div>
              </el-tooltip>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column label="订单类型" width="150" :fixed="selectedColumns.indexOf('order_reg_name') !== -1">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.order_reg && scope.row.order_reg.order_reg_name === '单品'" :content="scope.row.meal_singles.length > 0 ? getMeals(scope.row.meal_singles) : ''
              " placement="top">
              <span class="count-style" v-if="scope.row.order_reg">
                {{ scope.row.order_reg.order_reg_name }}:{{
                  getMeals(scope.row.meal_singles)
                }}
              </span>
            </el-tooltip>
            <template v-else>
              <div style="display: flex; align-items: center">
                <el-tooltip v-if="scope.row.more_reg_order.length > 1" content="该用户有多个云上公司注册订单">
                  <i v-if="scope.row.more_reg_order.length > 1" class="el-icon-warning"></i>
                </el-tooltip>
                <el-tooltip v-if="scope.row.order_reg" :content="scope.row.order_reg.order_reg_name">
                  <span class="count-style">
                    {{ scope.row.order_reg ? scope.row.order_reg.order_reg_name : "" }}
                  </span>
                </el-tooltip>
              </div>
            </template>
            <div style="display: flex; align-items: center">
              <el-tooltip v-if="scope.row.order_reg && scope.row.order_reg.order_reg_name === '单品'
              " content="是否续费" placement="top">
                <el-tag type="success" effect="dark" size="mini">{{
                  scope.row.is_renew
                }}</el-tag>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" width="100" :fixed="selectedColumns.indexOf('order_status') !== -1">
          <template slot-scope="scope">
            <el-link disabled type="primary" slot="reference">{{
              scope.row.order_status
            }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="转化人员" width="140" :fixed="selectedColumns.indexOf('convert') !== -1">
          <template slot-scope="scope">
            <span v-if="scope.row.convert">{{ scope.row.trans.username }}</span>
            <span v-else>自助下单</span>
            <div>
              <el-tooltip :content="scope.row.converted_at !== null ? '转化时间' : '派单时间'" placement="top">
                <span class="count-style">
                  <date-formatter
                    :date-value="scope.row.converted_at !== null ? scope.row.converted_at : scope.row.assign_at"></date-formatter>
                </span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="沟通专员(业务)" width="140" :fixed="selectedColumns.indexOf('advisor') !== -1">
          <template slot-scope="scope">
            <div v-if="scope.row.advisor">
              <span class="count-style">{{
                scope.row.advisor ? scope.row.advisor.username : ""
              }}</span>
              <div>
                <el-tooltip content="分配时间" placement="top">
                  <span class="count-style" v-if="scope.row.assign_chater_time">
                    <date-formatter :date-value="scope.row.assign_chater_time"></date-formatter>
                  </span>
                </el-tooltip>
              </div>
            </div>
            <div v-else>
              <el-tooltip content="订单创建时间距今已超过7天未分配人员" placement="top">
                <span v-if="switchTime(currentTime) - switchTime(scope.row.created_at) >= 604800
                ">
                  <i class="el-icon-warning"></i>
                  <span style="color: #d02323">分配超时</span>
                </span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="沟通状态" width="140" :fixed="selectedColumns.indexOf('chat_status') !== -1">
          <template slot-scope="scope">
            <div v-if="scope.row.chat_status === '未分配'">
              <span class="dot" style="background-color: #4d84ff"></span>
              <el-popconfirm title="确定认领该订单吗？" @onConfirm="handelAssign(scope.$index, scope.row)">
                <el-link type="primary" slot="reference">{{
                  scope.row.chat_status
                }}</el-link>
              </el-popconfirm>
            </div>
            <div v-else-if="scope.row.chat_status === '待沟通'">
              <span class="dot" style="background-color: #88d023"></span>
              <el-link disabled>{{ scope.row.chat_status }}</el-link>
            </div>
            <div v-else-if="scope.row.chat_status === '沟通中'">
              <span class="dot" style="background-color: #88d023"></span>
              <el-link disabled>{{ scope.row.chat_status }}</el-link>
            </div>
            <div v-else-if="scope.row.chat_status === '联系不到'">
              <span class="dot" style="background-color: #d02323"></span>
              <el-link disabled>{{ scope.row.chat_status }}</el-link>
            </div>
            <div v-else>
              <span class="dot" style="background-color: #d02323"></span>
              <el-link disabled>{{ scope.row.chat_status }}</el-link>
            </div>
            <div v-if="scope.row.reflects.length > 0">
              <el-popover placement="right" trigger="click" title="沟通记录" width="600">
                <div class="popoverList">
                  <el-timeline>
                    <el-timeline-item class="time_class" v-for="(activity, index) in activitiesShow" :key="index"
                      :icon="activity.icon" :type="activity.type" :color="activity.color" :size="activity.size">
                      <span style="
                          color: #666666;
                          display: inline-block;
                          margin-bottom: 0.2rem;
                        ">{{ activity.executor + "于" }}</span>
                      <span style="color: #666666">
                        <!-- {{ activity.created_at }} -->
                        <date-formatter :date-value="scope.row.created_at"></date-formatter>
                      </span>
                      <span style="color: #666666">{{ activity.contact_type }}</span>
                      <div class="time_right">
                        <span>{{ activity.reflect_content }}</span>
                      </div>
                      <div class="time_right">
                        <el-link class="handleLinkImg" v-for="(items, indexs) in activity.images" :key="indexs"
                          @click="handleLinkImgS(indexs, index)" type="primary">
                          {{ "图片" + (indexs + 1) }}
                        </el-link>
                      </div>
                    </el-timeline-item>
                    <div v-if="scope.row.reflects.length <= 0">没有记录</div>
                  </el-timeline>
                </div>
                <el-button style="padding: 0; border: 0" slot="reference" @click="enter(scope.row.id)">
                  <!-- {{ scope.row.reflects[0].created_at }} -->
                  <date-formatter :date-value="scope.row.reflects[0].created_at"></date-formatter>
                </el-button>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="服务人员" width="140" :fixed="selectedColumns.indexOf('operator_name') !== -1">
          <template slot-scope="scope">
            <div v-if="!scope.row.operator">
              <el-button icon="el-icon-user" circle size="mini" @click="handleOpenOperator(scope.$index, scope.row.id)">
              </el-button>
              <br />
              <el-tooltip content="订单创建时间距今已超过24小时未分配人员" placement="top">
                <span v-if="switchTime(currentTime) - switchTime(scope.row.created_at) >= 86400
                ">
                  <i class="el-icon-warning"></i>
                  <span style="color: #d02323">分配超时</span>
                </span>
              </el-tooltip>
            </div>
            <div v-else>
              <span>{{ scope.row.operator !== null ? scope.row.operator.username : '' }}</span>
              <el-tooltip content="分配时间" placement="top">
                <span class="count-style">
                  <!-- {{ scope.row.first_assign_server_time }} -->
                  <date-formatter :date-value="scope.row.first_assign_server_time"></date-formatter>
                </span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="服务状态" width="90" :fixed="selectedColumns.indexOf('service_status') !== -1">
          <template slot-scope="scope">
            <div v-if="scope.row.service_status === '未分配'">
              <span class="dot" style="background-color: #88d023"></span>
              <el-link disabled>{{ scope.row.service_status }}</el-link>
            </div>
            <div v-else-if="scope.row.service_status === '待服务'">
              <span class="dot" style="background-color: #88d023"></span>
              <el-link disabled>{{ scope.row.service_status }}</el-link>
            </div>
            <div v-else-if="scope.row.service_status === '服务中'">
              <span class="dot" style="background-color: #88d023"></span>
              <el-link disabled>{{ scope.row.service_status }}</el-link>
            </div>
            <div v-else-if="scope.row.service_status === '服务完成'">
              <span class="dot" style="background-color: #d02323"></span>
              <el-link disabled>{{ scope.row.service_status }}</el-link>
            </div>
            <div v-else-if="scope.row.service_status === '服务暂停'">
              <span class="dot" style="background-color: #d02323"></span>
              <el-link disabled>{{ scope.row.service_status }}</el-link>
            </div>
            <div v-else>
              <span class="dot" style="background-color: #d02323"></span>
              <el-link disabled>{{ scope.row.service_status }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="公司名称" width="140" :fixed="selectedColumns.indexOf('company_name') !== -1">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.company_obj ? scope.row.company_obj.company_name : ''" placement="top">
              <span class="count-style">
                {{ scope.row.company_obj ? scope.row.company_obj.company_name : "" }}
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="订单金额" width="180" :fixed="selectedColumns.indexOf('total_amount') !== -1">
          <template slot-scope="scope">
            <div>
              <span class="count-style">{{ scope.row.total_amount }}</span>
            </div>
            <div style="display: flex">
              <el-tooltip v-if="scope.row.receipt_pic.length > 0" content="收款凭证" placement="top">
                <el-tag style="cursor: pointer" type="" effect="dark" @click="lookReceiveVoucher(scope.row.receipt_pic)"
                  size="mini">有</el-tag>
              </el-tooltip>
              <el-tooltip content="收款方式" placement="top">
                <span class="count-style">{{
                  scope.row.money_in !== null ? scope.row.money_in.category_name : "无"
                }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="客户来源" width="100" :fixed="selectedColumns.indexOf('source_name') !== -1">
          <template slot-scope="scope">
            <span class="count-style">{{
              scope.row.source ? scope.row.source.source_name : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户姓名" width="100" :fixed="selectedColumns.indexOf('customer_name') !== -1">
          <template slot-scope="scope">
            <span class="count-style">{{ scope.row.customer_name ? scope.row.customer_name : "未知" }}
              <br />
              <el-tag type="success" effect="dark" size="mini">订单：{{ scope.row.phone_num_count }}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="客户手机" width="180" :fixed="selectedColumns.indexOf('customer_phone') !== -1">
          <template slot-scope="scope">
            <!-- 注释勿删 -->
            <!-- <el-tooltip :content="scope.row.customer_phone" placement="top"> -->
            <!-- <span class="count-style">
              <el-link
                style="color: #409eff; cursor: pointer"
                @click="
                  openPhoneFromDraw(
                    scope.row.customer_phone_code
                      ? scope.row.customer_phone_code
                      : scope.row.vagary_phone
                  )
                "
                >{{ scope.row.vagary_phone ? scope.row.vagary_phone.slice(0, 5) : "" }}
              </el-link> -->
            <phone-com :comPhone="scope.row.customer_phone" :vagaryPhone="scope.row.vagary_phone_custome"
              style="display: inline-block" />
            <el-tooltip effect="drak" content="电话外呼" placement="bottom">
              <!-- <i @click="makePhone(scope.row.customer_phone)" class="el-icon-phone-outline" -->
              <i @click="
                makePhone(
                  scope.row.vagary_phone_custome
                    ? scope.row.vagary_phone_custome
                    : scope.row.customer_phone
                )
                " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
            </el-tooltip>
            <!-- <vagary-phone
                style="display: inline-block"
                v-if="hasDecryptPhonePower === true"
                :vagary_phone="
                  scope.row.customer_phone_code
                    ? scope.row.customer_phone_code
                    : scope.row.vagary_phone
                "
              /> -->
            <br />
            <span v-if="scope.row.phone_customer_isp">{{ scope.row.phone_customer_isp.province }}&nbsp;&nbsp;{{
              scope.row.phone_customer_isp.city
            }}
            </span>
            <!-- </span> -->
            <!-- </el-tooltip> -->
          </template>
        </el-table-column>
        <el-table-column label="客户隶属" width="100" :fixed="selectedColumns.indexOf('customer_belongs') !== -1">
          <template slot-scope="scope">
            <span class="count-style" v-if="scope.row.customer_belongs === 1">线上</span>
            <span class="count-style" v-else-if="scope.row.customer_belongs === 2">线下</span>
            <span class="count-style" v-else>未知</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <div class="operation">
              <el-tooltip class="item" effect="dark" content="编辑订单" placement="top">
                <el-button type="text" size="medium" @click="handleEditOpen(scope.$index, scope.row)">编辑</el-button>
              </el-tooltip>
              <el-dropdown trigger="click" style="margin-left: 0.4rem; top: 0.04rem; cursor: pointer; color: #409eff">
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="handCallLogsOpen(scope.row)"><span><img class="icon-class"
                        src="/static/record.svg" /></span>电话沟通记录</el-dropdown-item>
                  <el-dropdown-item v-show="scope.row.wx_work_chat_com"
                    :disabled="scope.row.wx_work_chat_com ? false : true" @click.native="
                      handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.id)
                      "><span><img class="icon-class" src="/static/record.svg" /></span>企微聊天记录</el-dropdown-item>
                  <el-dropdown-item v-show="!scope.row.wx_work_chat_com"
                    :disabled="scope.row.wx_work_chat_com ? true : false"
                    @click.native="openBindWeChatDrawer(scope.row)"><span><img class="icon-class"
                        src="/static/bind.svg" /></span>绑定企业微群</el-dropdown-item>
                  <el-dropdown-item :disabled="scope.row.order_status === '已退款' ||
                    scope.row.order_status === '系统结单' ||
                    scope.row.order_status === '申请退款中'
                    " @click.native="applyRefundOrder(scope.$index, scope.row)"><span><img class="icon-class"
                        src="/static/apply.svg" /></span>申请退款</el-dropdown-item>
                  <el-dropdown-item :disabled="scope.row.refund_status != 0 ||
                    scope.row.order_status === '已退款' ||
                    scope.row.order_status === '系统结单' ||
                    scope.row.order_status === '申请退款中'
                    " @click.native="handelRefundReturnSubmit(scope.$index, scope.row)"><span><img class="icon-class"
                        src="/static/apply_refund.svg" /></span>撤回退款申请</el-dropdown-item>
                  <el-dropdown-item :disabled="scope.row.order_status === '系统结单'"
                    @click.native="systemOverOrder(scope.$index, scope.row)"><span><img class="icon-class"
                        src="/static/over_order.svg" /></span>系统结单</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.platform === '支付宝广告' && roleAuth.includes(9) === true
                  " :disabled="scope.row.order_status === '已退款' ||
                    scope.row.order_status === '系统结单'
                    " @click.native="alipayRefundOrder(scope.$index, scope.row)"><span><img class="icon-class"
                        src="/static/refund.svg" /></span>退款</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-else class="loading-placeholder">加载中，请稍后...</div>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination background class="tr" layout="total, sizes, prev, pager, next, jumper" :hide-on-single-page="false"
        :current-page="pageOption.currentPage" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="pageOption.pageSize"
        :total="pageOption.total" @size-change="handleSizeChange" @current-change="handleCurrentChange">
      </el-pagination>
    </el-footer>

    <el-drawer title="录入" :visible.sync="addDrawer" direction="rtl" :before-close="handleAddDrawerBeforeClose"
      size="60%">
      <div class="m-tabs-content">
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>订单基础信息</span>
            </div>
            <div>
              <el-row>
                <el-col :span="2" class="m-label">派单时间</el-col>
                <el-col :span="4">
                  <el-date-picker v-model="addForm.assign_at" :size="inputSize" type="date" value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-col>
                <el-col :span="2" :offset="1" class="m-label">订单来源</el-col>
                <el-col :span="4">
                  <el-cascader ref="cascaderOrderFromInput" v-model="addForm.platform" placeholder="请选择"
                    :options="fromOptions" :size="inputSize" :props="{ expandTrigger: 'hover', emitPath: false }"
                    clearable filterable @visible-change="handleVisibleChange($event, 'order_from')"
                    :filter-method="filterOptions">
                  </el-cascader>
                </el-col>
                <el-col :span="2" :offset="1" class="m-label">订单编号</el-col>
                <el-col :span="4">
                  <el-input v-model="addForm.order_num" :size="inputSize" clearable placeholder=""></el-input>
                </el-col>
                <el-col :span="2" style="margin-left: 0.1rem">
                  <el-button type="primary" @click="generateOrderNum" size="small">生成订单号</el-button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2" class="m-label">城市园区</el-col>
                <el-col :span="5">
                  <el-select v-model="addForm.order_park" placeholder="请选择" :size="inputSize" filterable>
                    <el-option v-for="option in place_parks" :key="option.id" :label="option.name"
                      :value="option.id"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="2" :offset="1" class="m-label">订单分类</el-col>
                <el-col :span="6">
                  <el-radio-group v-model="addForm.order_cate" @input="getOrderRegType(addForm.order_cate, 0)"
                    :size="inputSize">
                    <el-radio-button :label="1">注册</el-radio-button>
                    <el-radio-button :label="2">套餐</el-radio-button>
                    <el-radio-button :label="3">单品</el-radio-button>
                  </el-radio-group>
                </el-col>
                <el-col v-if="addForm.order_cate !== 3" :span="2" :offset="1" class="m-label">订单类型</el-col>
                <el-col v-if="addForm.order_cate !== 3" :span="4">
                  <el-select @change="resetSomeValue" v-model="addForm.order_reg_type" placeholder="请选择"
                    :size="inputSize">
                    <el-option v-for="reg in orderRegTypes" :key="reg.order_reg_id" :label="reg.order_reg_name"
                      :value="reg.order_reg_id"></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row v-if="addForm.order_cate === 3">
                <el-col :span="2" class="m-label">单品名称</el-col>
                <el-col :span="21">
                  <el-select v-model="addForm.mealSingles" multiple filterable placeholder="请选择" clearable
                    :size="inputSize">
                    <el-option v-for="orderMeal in mealSingles" :key="orderMeal.item_id" :label="orderMeal.item_name"
                      :value="orderMeal.item_id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row v-if="addForm.order_cate !== null &&
                addForm.order_cate !== 1 &&
                addForm.order_reg_type !== 3 &&
                addForm.order_reg_type !== 14 &&
                addForm.order_reg_type !== 15
              ">
                <el-col :span="2" class="m-label">续费订单</el-col>
                <el-col :span="21" style="margin-top: 0.1rem">
                  <el-tooltip :content="addForm.is_renew" placement="top">
                    <el-switch v-model="addForm.is_renew" active-color="#5789F4" inactive-color="#dcdfe6"
                      active-value="是" inactive-value="否">
                    </el-switch>
                  </el-tooltip>
                </el-col>
              </el-row>
              <el-row v-if="addForm.order_cate !== null && addForm.order_cate !== 1">
                <el-col :span="2" class="m-label">公司名称</el-col>
                <el-col :span="9">
                  <el-select v-model="addForm.company_id" filterable remote reserve-keyword placeholder="输入公司"
                    size="mini" clearable :remote-method="remoteMethod" :loading="loading" @change="handleChangeCompany"
                    :disabled="hasCompanyState">
                    <el-option v-for="company in companies" :key="company.id" :label="company.company_name"
                      :value="company.id">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="2" :offset="1" style="margin-top: 0.1rem" v-if="addForm.order_cate !== null &&
                  addForm.order_cate !== 1 &&
                  addForm.is_renew === '否'
                ">
                  <el-checkbox v-model="addForm.has_company" size="mini" label="w"
                    @change="changeHasCompany">公司办理中</el-checkbox>
                </el-col>
              </el-row>
              <el-row v-if="addForm.is_renew === '是' &&
                addForm.company_id != null &&
                flow_tax.length !== 0
              ">
                <el-col :span="2" class="m-label">流水编号</el-col>
                <el-col :span="21">
                  <el-select v-model="addForm.flow_tax" filterable reserve-keyword size="mini" clearable
                    :loading="loading">
                    <el-option v-for="tax in flow_tax" :key="tax.id" :label="tax.acc_discharge_no"
                      :value="tax.acc_discharge_no">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row v-else-if="addForm.is_renew === '是' &&
                addForm.company_id != null &&
                flow_tax.length === 0
              ">
                <el-col :span="2" class="m-label">流水编号</el-col>
                <el-col :span="21">
                  <el-input v-model="addForm.flow_tax" :size="inputSize" clearable></el-input>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>服务商信息</span>
            </div>
            <div>
              <el-row>
                <el-col :span="2" class="m-label">服务商</el-col>
                <el-col :span="9">
                  <el-select v-model="addForm.service_business" filterable placeholder="请选择" clearable :size="inputSize"
                    @click.native="getServiceProvider">
                    <el-option v-for="option in serviceProvider" :key="option.id" :label="option.business_name"
                      :value="option.id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <el-row v-if="showMealSingles || isOrderRegTypeInclueded">
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>财务信息</span>
            </div>
            <div>
              <el-row>
                <el-col :span="2" class="tr m-label text_right">零申报</el-col>
                <el-col :span="20" :offset="1">
                  <el-radio-group v-model="addServer.is_zero" size="mini" :disabled="true">
                    <el-radio :label="1" border>是</el-radio>
                    <el-radio :label="2" border>否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2" class="tr m-label text_right">开始时间</el-col>
                <el-col :span="20" :offset="1">
                  <el-date-picker :disabled="true" v-model="addServer.begin_time" type="month" size="mini"
                    value-format="yyyy-MM" style="width: 100%">
                  </el-date-picker>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2" class="tr m-label text_right">服务时间</el-col>
                <el-col :span="20" :offset="1">
                  <el-date-picker v-model="addForm.server_time" type="monthrange" size="mini" value-format="yyyy-MM"
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" style="width: 70%">
                  </el-date-picker>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2" class="tr m-label text_right">是否赠送</el-col>
                <el-col :span="20" :offset="1">
                  <el-radio-group v-model="addForm.include_gifts" size="mini" @input="handleControl">
                    <el-radio :label="1" border>是</el-radio>
                    <el-radio :label="0" border>否</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-row v-if="addForm.include_gifts === 1">
                <el-col :span="2" class="tr m-label text_right">赠送时长</el-col>
                <el-col :span="20" :offset="1">
                  <el-input v-model.trim="addForm.gifts_length" maxlength="3" placeholder="请输入赠送时长（月）" size="mini"
                    clearable></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2" class="tr m-label text_right">收费标准</el-col>
                <el-col :span="20" :offset="1">
                  <el-input :disabled="true" v-model="addServer.take_money_rule" size="mini" clearable></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2" class="tr m-label text_right">增值服务</el-col>
                <el-col :span="20" :offset="1">
                  <el-table :data="addServer.take_money_rule_real" style="width: 100%" border>
                    <el-table-column label="服务名称" width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.value_add.name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="服务频次" width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.value_add.type }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="参考价格" width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.value_add.price }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="实际价格" width="100">
                      <template slot-scope="scope">
                        <span>{{ scope.row.price }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>客户信息</span>
            </div>
            <div>
              <el-row>
                <el-col :span="2" class="m-label">客户来源</el-col>
                <el-col :span="9">
                  <el-cascader ref="cascaderCustomerSourceInput" v-model="addForm.sources" placeholder="请选择"
                    :options="sources" :size="inputSize" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
                    filterable @visible-change="handleVisibleChange($event, 'customer_source')"
                    :filter-method="filterOptions">
                  </el-cascader>
                </el-col>
                <el-col :span="2" :offset="1" class="m-label">客户姓名</el-col>
                <el-col :span="9">
                  <el-input v-model="addForm.customer_name" :size="inputSize" clearable></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2" class="m-label">客户手机</el-col>
                <el-col :span="6">
                  <el-input v-model="addForm.customer_phone" :size="inputSize" clearable></el-input>
                </el-col>
                <!-- <el-col :span="3" style="margin-left: 0.12rem">
                  <el-button
                    style="padding: 9px 10px"
                    @click="getLinkedOrder(addForm.customer_phone)"
                    size="small"
                    type="primary"
                    >获取相关订单</el-button
                  >
                </el-col> -->
                <el-col :span="2" style="margin-left: 0.5rem" class="m-label">客户隶属</el-col>
                <el-col :span="9">
                  <el-radio-group v-model="addForm.customer_belongs" size="mini">
                    <el-radio-button v-for="item in customerBelongs" :label="item.id" :key="item.id">
                      {{ item.name }}
                    </el-radio-button>
                  </el-radio-group>
                </el-col>
              </el-row>
              <!-- <el-row v-if="addForm.is_renew === '是'">
                <el-col :span="2" class="m-label">绑定订单</el-col>
                <el-col :span="9">
                  <el-input
                    v-model="addForm.bind_order_num"
                    :size="inputSize"
                    clearable
                  ></el-input>
                </el-col>
                <el-col :span="12" :offset="1" class="m-label" style="color: red"
                  >注：根据客户手机获取相关订单，复制一个单号粘贴至此处！</el-col
                >
              </el-row> -->
            </div>
          </el-card>
        </el-row>
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>人员信息</span>
            </div>
            <div>
              <el-row>
                <el-col :span="2" class="m-label">转化人员</el-col>
                <el-col :span="5">
                  <el-cascader v-model="addForm.convert" placeholder="不选则为自助下单" :options="personnel" size="mini"
                    :props="{ expandTrigger: 'hover' }" clearable filterable :filter-method="filterOptions">
                  </el-cascader>
                </el-col>
                <el-col :span="2" :offset="1" class="m-label">沟通人员</el-col>
                <el-col :span="5">
                  <el-cascader v-model="addForm.consultant" placeholder="录入订单后再分配" :options="personnel" size="mini"
                    :props="{ expandTrigger: 'hover' }" :disabled="true" clearable filterable
                    :filter-method="filterOptions">
                  </el-cascader>
                </el-col>
                <el-col :span="2" :offset="1" class="m-label">服务人员</el-col>
                <el-col :span="5">
                  <el-cascader v-model="addForm.operator" placeholder="录入订单后再分配" :options="personnel" size="mini"
                    :props="{ expandTrigger: 'hover' }" :disabled="true" clearable filterable
                    :filter-method="filterOptions">
                  </el-cascader>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>收款信息</span>
            </div>
            <div>
              <el-row>
                <el-col :span="2" class="m-label">订单金额</el-col>
                <el-col :span="9">
                  <el-input v-model="addForm.total_amount" :size="inputSize" clearable></el-input>
                </el-col>
                <div v-if="addForm.moneyin != 18">
                  <el-col :span="2" :offset="1" class="m-label">支付时间</el-col>
                  <el-col :span="9">
                    <datetime-com :validate="true" :rules="datetimeRules" @handleDateChanged="handleDateChanged"
                      style="margin-top: -0.1rem" />
                  </el-col>
                </div>
              </el-row>
              <el-row>
                <el-col :span="2" class="m-label">收款方式</el-col>
                <el-col :span="9">
                  <el-cascader style="width: 100%" v-model="addForm.moneyin" placeholder="请选择"
                    :options="moneyInCateOptions" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }"
                    clearable filterable @click.native="loadMoneyInCate" :filter-method="filterOptions"
                    @change="handleMoneyinChange">
                  </el-cascader>
                </el-col>
              </el-row>
              <el-row v-if="addForm.moneyin != 18">
                <el-col :span="2" class="m-label" style="margin-top: 0.4rem">收款凭证</el-col>
                <el-col :span="21">
                  <el-upload action="https://weixin.qiyehuo.com/api/admin/tyc_order/upfile"
                    accept="image/png, image/jpeg, image/gif" :headers="headers" multiple ref="uploadMutiple"
                    :file-list="fileLists" :limit="limit" :before-upload="beforeAvatarUpload"
                    :on-success="handleAvatarSuccess" :on-change="handleAvatarChange"
                    :on-preview="handlePictureCardPreview" :on-remove="handleRemoveR">
                  </el-upload>
                  <div id="preview" @paste="handlePaste"
                    style="border: 2px dashed #409eff; border-radius: 5px; padding: 10px">
                    <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
                  </div>
                  <el-dialog :visible.sync="addDialogVisible" :modal="false">
                    <img width="100%" :src="addDialogImageUrl" alt="" />
                  </el-dialog>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
      </div>
      <el-row class="bottom-btn">
        <el-button @click="handleSave" size="mini" type="primary">保存</el-button>
      </el-row>
    </el-drawer>
    <el-drawer :title="'编辑： ' + saveForm.order_num" :visible.sync="upDrawer" direction="rtl" custom-class="AIdrawer"
      :before-close="handleUpdateClose" size="60%">
      <div class="drawer-title" slot="title">编辑： {{ saveForm.order_num }}</div>
      <edit-order :orderid="saveForm.id" @data-updated="handleDataUpdated"></edit-order>
    </el-drawer>
    <el-drawer title="" :visible.sync="bindWeChatDrawer" direction="rtl" :before-close="handleClose_weChatDrawer"
      size="65%">
      <template slot="title">
        <span style="color: #409eff; font-size: medium; font-weight: bold">绑定企业微信聊天群</span>
      </template>
      <div style="padding: 0 0.2rem">
        <BindWechat :order_num="OrderNum" @success="success" />
      </div>
    </el-drawer>
    <el-drawer title="企业微信聊天记录" :visible.sync="wxChatDrawer" direction="rtl" :before-close="handleWxChatBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat :chatId="wxWorkChatId" :chatName="wxWorkchatCompany"></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="dialogVisible" :before-close="handelDialogClose" class="el_dialogs" width="45%">
      <div>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="yun" label="云上"></el-table-column>
          <el-table-column prop="proxy_meal" label="套餐"></el-table-column>
          <el-table-column prop="item" label="单品"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog title="添加工单" :visible.sync="addWorkOrderVisible" width="45%" :before-close="handleAddWorkOrderClose">
      <el-form :model="workForm" :rules="rules" ref="workForm" label-width="100px">
        <el-form-item label="类型" prop="work_type">
          <el-select v-model="workForm.work_type" placeholder="请选择工单类型" clearable :size="inputSize">
            <el-option value="退款" label="退款"></el-option>
            <el-option value="催单" label="催单"></el-option>
            <el-option value="其他" label="其他"></el-option>
            <el-option value="催客户完结" label="催客户完结"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="work_content">
          <el-input type="textarea" v-model="workForm.work_content" placeholder="请输入工单内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submitWorkForm('workForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量分配人员" :visible.sync="operatorVisible" width="30%" :before-close="handleOperatorClose">
      <div style="margin-bottom: 0.4rem" v-if="batchTag">
        <el-cascader v-model="communicator" placeholder="请选择沟通人员" :options="personnel" size="mini"
          :props="{ expandTrigger: 'hover' }" clearable filterable :filter-method="filterOptions">
        </el-cascader>
      </div>
      <div style="margin-bottom: 0.4rem">
        <el-cascader v-model="operator" placeholder="请选择服务人员" :options="personnel" size="mini"
          :props="{ expandTrigger: 'hover' }" clearable filterable :filter-method="filterOptions">
        </el-cascader>
      </div>
      <div v-if="batchTag">
        <el-cascader v-model="sharer" placeholder="请选择共享人员" :options="personnel"
          :props="{ multiple: true, expandTrigger: 'hover' }" size="mini" clearable filterable
          :filter-method="filterOptions">
        </el-cascader>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleOperatorSave">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer title="电话联系记录" :visible.sync="callLogsDrawer" direction="rtl" :before-close="handleCallLogsBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs :company="company" :phone="callPhone" :phone1="callPhone1" :phone2="callPhone2"
            :phone3="callPhone3"></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="客户手机关联订单" :visible.sync="linkOrderDrawer" direction="rtl"
      :before-close="handlelinkOrderDrawerBeforeClose" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <link-order :currentTel="currentTel"></link-order>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="" :visible.sync="phoneFromDraw" direction="rtl" :before-close="closePhoneFromDraw" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <make-phone :phone1="phoneFrom_phone"></make-phone>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer :title="'订单信息： ' + OrderNum" :visible.sync="orderInfoVisible" :show-close="true" :modal="false"
      :withHeader="true" :wrapperClosable="true" direction="rtl" custom-class="AIdrawer" size="60%"
      :before-close="handleOrderInfoClose">
      <div class="drawer-title" slot="title">订单信息： {{ OrderNum }}</div>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId" @changeOrder="changeOrder" :checkType="orderType"
          @bind-invoice="doEmitBindInvoiceNo" @invoice-check="doEmitInvoiceCheck"></order-info>
      </div>
    </el-drawer>
    <el-drawer title="会员信息" :visible.sync="memberInfoDrawer" direction="rtl"
      :before-close="handleClose_memberInfoDrawer" size="50%">
      <div style="padding: 0.2em 1.4em; margin-top: 0.3rem">
        <member-info :phone="memberPhone"></member-info>
      </div>
    </el-drawer>
    <el-dialog title="绑定公司" :visible.sync="bindCompanyDialogVisible" width="30%">
      <el-form>
        <div style="text-align: center">
          <el-form-item>
            <el-select v-model="remote.company_id" filterable remote reserve-keyword placeholder="请输入公司名称筛选公司"
              size="mini" clearable :remote-method="companyBindRemote" :loading="bindcLoading" style="width: 100%">
              <el-option v-for="searchCompany in bindCompanyOptions" :key="searchCompany.id"
                :label="searchCompany.company_name" :value="searchCompany.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="doBind">绑定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="绑定流水号" :visible.sync="bindTaxNumberDialogVisible" width="50%" @close="clearUrl">
      <el-row class="m-tab">
        <el-col :span="4" class="m-th">
          <span class="count-style">公司名称</span>
        </el-col>
        <el-col :span="20" class="m-td">
          <span class="count-style">{{ flowdata.company_name }}</span>
        </el-col>
        <el-col :span="4" class="m-th">
          <span class="count-style">订单金额</span>
        </el-col>
        <el-col :span="8" class="m-td">
          <span class="count-style">{{ flowdata.total_amount }}</span>
        </el-col>
        <el-col :span="4" class="m-th">
          <span class="count-style">付款方式</span>
        </el-col>
        <el-col :span="8" class="m-td">
          <span class="count-style">{{ flowdata.money_in }}</span>
        </el-col>
      </el-row>
      <el-form>
        <div style="text-align: center">
          <el-form-item>
            <el-input v-model="remote.texNumber" clearable size="mini" placeholder="请输入企业流水号"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="doBindTaxNumber">绑定</el-button>
      </div>
      <div style="
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          text-align: center;
          padding: 0.2rem;
        ">
        <span v-if="evidenceUrlList.length > 0">
          <el-image v-for="(item, index) in evidenceUrlList" :key="index" style="width: 100%" :src="item.url"
            :preview-src-list="bigPreviewList">
          </el-image>
        </span>
        <span v-else style="color: #e6a23c; font-size: small">没有上传凭证!</span>
      </div>
    </el-dialog>
    <!-- 公司信息 开始 -->
    <el-drawer title="公司信息" :visible.sync="companyInfoDrawer" :append-to-body="true" direction="rtl"
      :before-close="handleCompanyInfoBeforeClose" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyInfoId"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <!-- 公司信息 结束 -->
    <!-- 合同详情 开始 -->
    <el-drawer title="合同详情" :visible.sync="contractDetailDrawer" direction="rtl" size="60%">
      <div style="padding: 0.2em 1.4em; margin-top: 0.3rem">
        <contract-detail :singleContract="singleContract"></contract-detail>
      </div>
    </el-drawer>
    <!-- 合同详情 结束 -->
    <!-- 流水号详情 开始 -->
    <el-drawer title="流水号详情" :visible.sync="flowDetailDrawer" direction="rtl" size="60%">
      <div style="padding: 0.2em 1.4em; margin-top: 0.3rem">
        <flow-detail :flowNumber="flowNumber"></flow-detail>
      </div>
    </el-drawer>
    <!-- 流水号详情 结束 -->
    <el-dialog title="绑定发票号" :visible.sync="invoiceOpenDrawer" width="70%" @close="handleInvoiceDialogClose">
      <span style="display: block; margin-bottom: 0.2rem; font-weight: bold">订单信息</span>
      <el-table border :data="orderDetailDate" tooltip-effect="dark" style="width: 100%; margin-bottom: 1rem">
        <el-table-column label="日期" width="100">
          <template slot-scope="scope">
            <span class="count-style">{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="公司名称" width="130">
          <template slot-scope="scope">
            <span class="count-style">{{ scope.row.company }}</span>
          </template>
        </el-table-column>
        <el-table-column label="付款方式" width="100">
          <template slot-scope="scope">
            <span class="count-style">{{ scope.row.money_in ? scope.row.money_in.category_name : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="金额" width="80">
          <template slot-scope="scope">
            <span class="count-style">{{ scope.row.total_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单类型" width="100">
          <template slot-scope="scope">
            <span class="count-style" v-if="scope.row.order_reg">
              {{ scope.row.order_reg.order_reg_name }}:{{
                getMeals(scope.row.meal_singles)
              }}
            </span>
            <span class="count-style" v-else>
              {{ scope.row.order_reg ? scope.row.order_reg.order_reg_name : "" }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!-- <span style="display: block; margin-bottom: 0.2rem; font-weight: bold">发票信息</span> -->
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.2rem;">
        <span style="font-weight: bold">发票信息</span>
        <el-checkbox v-model="checked" label="该订单暂未开票" @change="handleInvoiceCheck"
          v-show="showType === 1"></el-checkbox>
      </div>
      <el-table ref="multipleTable" border :data="companyInvoiceData" tooltip-effect="dark" style="width: 100%"
        @selection-change="handleSelectChange" :row-class-name="getRowClassName">
        <el-table-column v-if="showType === 1" type="selection" width="50" :selectable="isSelectable"></el-table-column>
        <el-table-column prop="incoice_num" label="发票号" width="80"></el-table-column>
        <el-table-column prop="e_incoice_num" label="数电发票号码" width="115"></el-table-column>
        <el-table-column prop="buyer_company" label="公司名称" width="145"></el-table-column>
        <el-table-column prop="invoice_date" label="开票日期" width="100"></el-table-column>
        <el-table-column prop="goods_name" label="商品名称" width="150"></el-table-column>
        <el-table-column prop="amount" label="金额" width="80"></el-table-column>
      </el-table>
      <el-checkbox v-model="special_checked" label="特殊订单" v-show="showType === 1"
        style="margin-top:0.1rem"></el-checkbox>
      <div slot="footer" class="dialog-footer" style="margin-top:-1.1rem">
        <el-button v-if="showType === 1 && !checked" size="mini" type="primary" @click="doBindInvoiceNo">绑定</el-button>
      </div>
    </el-dialog>
    <!-- 同步支付宝推广订单 -->
    <el-dialog title="同步支付宝推广订单" :visible.sync="alipayOrderSyncDrawer" width="45%">
      <el-form label-width="100px">
        <el-form-item label="请求信息串">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="alipayOrder.keyString"
            placeholder="请输入请求数据的信息串"></el-input>
        </el-form-item>
        <el-form-item label="选择日期">
          <el-date-picker size="mini" v-model="alipayOrder.syncDate" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submitStartSyncOrder()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 系统结单 -->
    <el-dialog title="系统结单" :visible.sync="systemOverOrderDrawer" width="45%">
      <el-form label-width="100px">
        <el-form-item label="系统结单理由">
          <el-input type="textarea" v-model="systemOverOrderData.feedback" size="mini"
            placeholder="请输入系统结单理由"></el-input>
        </el-form-item>
        <el-form-item label="上传结单凭证" class="ticket">
          <el-upload action="https://weixin.qiyehuo.com/api/admin/tyc_order/up_overorder_file" :headers="headers"
            multiple ref="overUploadMutiple" :file-list="overFileLists" :limit="limit"
            :before-upload="beforeAvatarUpload" :on-success="overHandleAvatarSuccess"
            :on-change="overHandleAvatarChange" :on-preview="overHandlePictureCardPreview"
            :on-remove="overHandleRemoveR">
          </el-upload>
          <div id="overPreview" @paste="overHandlePaste"
            style="border: 2px dashed #409eff; border-radius: 5px; padding: 10px">
            <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
          </div>
          <el-dialog :visible.sync="overDialogVisible" :modal="false">
            <img width="100%" :src="overDialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submitSystemOverOrder()">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 申请退款 -->
    <el-dialog title="申请退款" :visible.sync="applyRefundOrderDrawer" width="45%">
      <el-form label-width="100px">
        <el-form-item label="是否可退款">
          <el-select v-model="applyRefundOrderFeedback.refundable" :size="inputSize" placeholder="请选择">
            <el-option value="全额退款" label="全额退款"></el-option>
            <el-option value="部分退款" label="部分退款"></el-option>
            <el-option value="拒绝退款" label="拒绝退款"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部分退款金额" v-show="applyRefundOrderFeedback.refundable === '部分退款'">
          <el-input type="number" min="1" v-model="applyRefundOrderFeedback.return_money" size="mini"
            placeholder="请填写部分退款金额"></el-input>
        </el-form-item>
        <el-form-item label="退款原因">
          <el-select v-model="applyRefundOrderFeedback.reason_for_return" :size="inputSize" clearable placeholder="请选择">
            <el-option v-for="cause in causes" :key="cause.refund_id" :label="cause.refund_cause"
              :value="cause.refund_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款优先级">
          <el-select v-model="applyRefundOrderFeedback.refund_priority" :size="inputSize" placeholder="请选择">
            <el-option value="普通" label="普通"></el-option>
            <el-option value="紧急" label="紧急"></el-option>
            <el-option value="非常紧急" label="非常紧急"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否原路退款">
          <el-radio-group v-model="applyRefundOrderFeedback.is_init_refund" size="mini">
            <el-radio-button label="1">是</el-radio-button>
            <el-radio-button label="0">否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="收款银行" v-show="applyRefundOrderFeedback.is_init_refund === '0'">
          <el-input type="text" v-model="applyRefundOrderFeedback.receive_bank" size="mini"
            placeholder="请输入收款银行"></el-input>
        </el-form-item>
        <el-form-item label="收款卡号" v-show="applyRefundOrderFeedback.is_init_refund === '0'">
          <el-input type="text" v-model="applyRefundOrderFeedback.receive_card_no" size="mini"
            placeholder="请输入收款卡号"></el-input>
        </el-form-item>
        <el-form-item label="收款账户名称" v-show="applyRefundOrderFeedback.is_init_refund === '0'">
          <el-input type="text" v-model="applyRefundOrderFeedback.receive_card_acc" size="mini"
            placeholder="请输入收款账户名称"></el-input>
        </el-form-item>
        <el-form-item label="反馈来源">
          <el-select v-model="applyRefundOrderFeedback.feedback_source" :size="inputSize" placeholder="请选择">
            <el-option value="服务商" label="服务商"></el-option>
            <el-option value="平台" label="平台"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款原因叙述">
          <el-input type="textarea" v-model="applyRefundOrderFeedback.feedback" size="mini"
            placeholder="请输入退款原因具体描述"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submitApplyRefundOrder()">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 批量更新号码归属地 -->
    <el-dialog :visible.sync="updatePhoneFromDialog" width="30%">
      <el-form label-width="100px">
        <el-form-item label="选择日期范围">
          <el-date-picker size="mini" v-model="batchUpdate.telsp" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="选择数据表">
          <el-select v-model="batchUpdate.data_table" :size="inputSize" clearable placeholder="请选择">
            <el-option label="订单列表" :value="1">qyh_tyc_orders</el-option>
            <el-option label="客户列表" :value="2">qyh_users</el-option>
            <el-option label="公海线索表" :value="3">qyh_public_threads</el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="startBatchUpdateTelsp()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="lookReceiveVoucherDialog" :modal="false">
      <div v-for="(item, index) in picList" :key="item.name" style="margin-bottom: 0.4rem">
        <img height="50%" width="50%" :src="item.receive_url" alt="" />
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import PhoneCom from "common/PhoneCom";
import BindWechat from "common/BindWeChat";
import WxWorkChat from "common/WxWorkChat";
import DateFormatter from "common/DateFormatter";
import CallLogs from "common/CallLogs";
import MakePhone from "common/MakePhone";
import OrderInfo from "common/OrderInfo";
import MemberInfo from "common/MemberInfo";
import CompanyInfo from "common/CompanyInfo";
import ContractDetail from "common/ContractDetail";
import FlowDetail from "common/FlowDetail";
import LinkOrder from "common/LinkOrder";
import { fscDate } from "../../../static/mixins/fastChooseDate";
import { timeMixin } from "../../lib/timeMixin.js";
import VagaryPhone from "common/VagaryPhoneDecryption";
import { common } from "../../../static/mixins/common";
import DatetimeCom from '../../commonReform/DatetimeCom'
import EditOrder from "./components/EditOrder";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import { hyperfHost } from '@/YsyCollections/host/hyperfHost.js'
export default {
  name: "TycOrder",
  mixins: [fscDate, timeMixin, common],
  props: {
    user: Object,
  },
  components: {
    CallLogs,
    OrderInfo,
    MemberInfo,
    CompanyInfo,
    ContractDetail,
    FlowDetail,
    MakePhone,
    WxWorkChat,
    LinkOrder,
    BindWechat,
    VagaryPhone,
    DateFormatter,
    PhoneCom,
    EditOrder,
    DatetimeCom,
  },
  data() {
    return {
      datetimeRules: [{ required: true, message: '请填写支付日期', trigger: 'blur' }],
      hyperfHost:
        process.env.NODE_ENV === "development"
          ? "http://127.0.0.1:80"
          : "https://qyh-next-server.zhang66.cn",
      activeOpen: "",
      orderType: this.$feedBackConfig.order_chat,
      hasDecryptPhonePower: false,
      OrderNum: "",
      bindWeChatDrawer: false,
      checkedCustomer: false,
      checkedOrder: false,
      checkedOthers: false,
      checkedRefund: false,
      addServer: {
        cid: null,
        take_money_rule: "",
        take_money_rule_real: [],
        begin_time: "",
        is_zero: "",
      },
      valueAddedOptions: [],
      SelectedValueAddedOptions: [],
      phoneSource: {
        pro: "",
        city: "",
      },
      batchUpdate: {
        telsp: "",
        data_table: "",
      },
      updatePhoneFromDialog: false,
      wxChatDrawer: false,
      wxWorkChatId: "",
      wxWorkchatCompany: "",
      hugeSign: false,
      hugeData: [],
      addDialogVisible: false,
      addDialogImageUrl: "",
      editDialogVisible: false,
      overDialogVisible: false,
      overDialogImageUrl: "",
      flowdata: {
        company_name: "",
        total_amount: 0,
        money_in: "",
      },
      evidenceUrlList: [],
      bigPreviewList: [],
      phoneFrom_phone: [],
      phoneFromDraw: false,
      bindCompanyDialogVisible: false,
      memberPhone: null,
      memberInfoDrawer: false,
      moneyInCateOptions: [],
      orderNumChange: false,
      sources: [],
      operatorVisible: false,
      operator: [], // 服务人员
      communicator: [], // 沟通人员
      sharer: [], // 共享人员
      operatorIndex: null,
      operatorId: null,
      groupVisible: false,
      defaultName: "???",
      defaultSrc: "",
      avtiveChat: null,
      videoSrc: "",
      contactCount: {
        not: 0,
        timeOut3: 0,
        timeOut5: 0,
        timeOut7: 0,
        timeOut15: 0,
        timeOut30: 0,
      },
      schedules: [],
      uploadedList: [],
      pageNodes: [],
      tableData: [],
      dialogVisible: false,
      addWorkOrderVisible: false,
      rules: {
        work_content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        work_type: [{ required: true, message: "请选择工单类型", trigger: "blur" }],
      },
      upRules: {
        results: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
      workForm: {
        work_content: "",
        work_type: null,
      },
      uploadHeader: { Authorization: localStorage.token },
      imgPath: this.$store.state.imgPath,
      search: "",
      remote: {
        company_id: null,
        texNumber: "",
        invoiceNo: "",
      },
      searchArr: {
        pro: "",
        city: "",
        license_at: [],
        orderNum: "",
        order_status: "",
        chat_status: "",
        service_status: "",
        consultant: "",
        convert: "",
        orderRegType: [],
        orderDate: "",
        refund_date: "",
        reason_for_return: null,
        order_park: null,
        workOrder: null,
        contact_time: [],
        next_contact_time: [],
        timeOut: null,
        operator: null,
        mealSingles: [],
        sources: null,
        platform: null,
        is_renew: null,
        is_old_cus_out: "",
        is_member: "",
        moneyin: [],
        is_check_account: "",
        is_open_ticket: "",
        not_invoiced: '',
        is_bind_company: "",
        is_bind_client: "",
        is_sign_contract: "",
        UlFailReason: "",
        intention: null,
        customer_belongs: null,
        sharer: [],
        is_bind_we_group: null,
        established_at: [],
        assign_chater_time: "", // 分配沟通人员时间
      },
      inputSize: "small",
      pageData: [],
      orders: [],
      personnel: [],
      orderRegs: [],
      orderRegTypes: [],
      regTypes: [],
      citys: [],
      meals: [],
      mealSingles: [],
      causes: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1,
        pageSize: 30, // 每页显示条数
      },
      addDrawer: false,
      upDrawer: false,
      addForm: {
        flow_tax: "",
        order_park: 1,
        platform: "",
        order_num: "",
        total_amount: 0,
        customer_name: "",
        customer_phone: "",
        assign_at: "",
        order_cate: null,
        order_reg_type: null,
        convert: "",
        has_company: false,
        is_renew: "否",
        company_id: null,
        mealSingles: [],
        moneyin: "",
        customer_belongs: "1",
        sources: null,
        server_time: [],
        include_gifts: false,
        gifts_length: "",
        bind_order_num: "",
        service_business: "企业火",
        pay_moment: ''
      },
      saveForm: {
        acc_discharge_no: "",
        index: null,
        id: 0,
        order_num: "",
        assign_at: "",
        reason_for_return: [],
        reason_for_return_info: "",
        refund_date: "",
        mealSingles: [],
        consultant: [],
        convert: [],
        operator: [],
        total_amount: 0,
        customer_name: "",
        refundable: null,
        order_cate: null,
        customer_belongs: null,
        order_reg_type: null,
        refund_priority: "",
        feedback_source: "",
        sources: null,
        platform: "",
        companies: [],
        editFileLists: [],
        company: "",
        company_id: null,
        is_renew: "否",
        moneyin: "",
        service_business: "企业火",
        server_time: [],
        include_gifts: false,
        gifts_length: "",
      },
      modalKey: 0,
      saveOrderRegs: [],
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              const todayDate = this.today();
              picker.$emit("pick", todayDate);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const yesterdayDate = this.yesterday();
              picker.$emit("pick", yesterdayDate);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              const thisWeekDate = this.thisWeek();
              picker.$emit("pick", thisWeekDate);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              const prevWeekDate = this.prevWeek();
              picker.$emit("pick", prevWeekDate);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              const thisMonDate = this.thisMon();
              picker.$emit("pick", thisMonDate);
            },
          },
          {
            text: "上月",
            onClick: (picker) => {
              const lastMonDate = this.lastMon();
              picker.$emit("pick", lastMonDate);
            },
          },
        ],
      },
      refundPicker: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              const todayDate = this.today();
              picker.$emit("pick", todayDate);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const yesterdayDate = this.yesterday();
              picker.$emit("pick", yesterdayDate);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              const thisWeekDate = this.thisWeek();
              picker.$emit("pick", thisWeekDate);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              const prevWeekDate = this.prevWeek();
              picker.$emit("pick", prevWeekDate);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              const thisMonDate = this.thisMon();
              picker.$emit("pick", thisMonDate);
            },
          },
          {
            text: "上月",
            onClick: (picker) => {
              const lastMonDate = this.lastMon();
              picker.$emit("pick", lastMonDate);
            },
          },
        ],
      },
      contactPicker: {
        shortcuts: [
          {
            text: "今日",
            onClick: () => {
              const start = new Date();
              start.setHours(0, 0, 0);
              const end = new Date();
              end.setHours(23, 59, 59);
              this.searchArr.contact_time = [start, end];
            },
          },
          {
            text: "昨日",
            onClick: () => {
              const start = new Date();
              start.setDate(start.getDate() - 1);
              start.setHours(0, 0, 0);
              const end = new Date();
              end.setDate(end.getDate() - 1);
              end.setHours(23, 59, 59);
              this.searchArr.contact_time = [start, end];
            },
          },
          {
            text: "本周",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay()
              );
              start.setHours(0, 0, 0);
              const end = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay() + 6
              );
              end.setHours(23, 59, 59);
              this.searchArr.contact_time = [start, end];
            },
          },
          {
            text: "上周",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay() - 7
              );
              start.setHours(0, 0, 0);
              const end = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay() - 1
              );
              end.setHours(23, 59, 59);
              this.searchArr.contact_time = [start, end];
            },
          },
          {
            text: "本月",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                1
              );
              start.setHours(0, 0, 0);
              const end = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth() + 1,
                0
              );
              end.setHours(23, 59, 59);
              this.searchArr.contact_time = [start, end];
            },
          },
          {
            text: "上月",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth() - 1,
                1
              );
              start.setHours(0, 0, 0);
              const end = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
              end.setHours(23, 59, 59);
              this.searchArr.contact_time = [start, end];
            },
          },
        ],
      },
      nextContactPicker: {
        shortcuts: [
          {
            text: "今日",
            onClick: () => {
              const start = new Date();
              start.setHours(0, 0, 0);
              const end = new Date();
              end.setHours(23, 59, 59);
              this.searchArr.next_contact_time = [start, end];
            },
          },
          {
            text: "昨日",
            onClick: () => {
              const start = new Date();
              start.setDate(start.getDate() - 1);
              start.setHours(0, 0, 0);
              const end = new Date();
              end.setDate(end.getDate() - 1);
              end.setHours(23, 59, 59);
              this.searchArr.next_contact_time = [start, end];
            },
          },
          {
            text: "本周",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay()
              );
              start.setHours(0, 0, 0);
              const end = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay() + 6
              );
              end.setHours(23, 59, 59);
              this.searchArr.next_contact_time = [start, end];
            },
          },
          {
            text: "上周",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay() - 7
              );
              start.setHours(0, 0, 0);
              const end = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay() - 1
              );
              end.setHours(23, 59, 59);
              this.searchArr.next_contact_time = [start, end];
            },
          },
          {
            text: "本月",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                1
              );
              start.setHours(0, 0, 0);
              const end = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth() + 1,
                0
              );
              end.setHours(23, 59, 59);
              this.searchArr.next_contact_time = [start, end];
            },
          },
          {
            text: "上月",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth() - 1,
                1
              );
              start.setHours(0, 0, 0);
              const end = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
              end.setHours(23, 59, 59);
              this.searchArr.next_contact_time = [start, end];
            },
          },
        ],
      },
      licensePicker: {
        shortcuts: [
          {
            text: "今日",
            onClick: () => {
              const start = new Date();
              start.setHours(0, 0, 0);
              const end = new Date();
              end.setHours(23, 59, 59);
              this.searchArr.license_at = [start, end];
            },
          },
          {
            text: "昨日",
            onClick: () => {
              const start = new Date();
              start.setDate(start.getDate() - 1);
              start.setHours(0, 0, 0);
              const end = new Date();
              end.setDate(end.getDate() - 1);
              end.setHours(23, 59, 59);
              this.searchArr.license_at = [start, end];
            },
          },
          {
            text: "本周",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay()
              );
              start.setHours(0, 0, 0);
              const end = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay() + 6
              );
              end.setHours(23, 59, 59);
              this.searchArr.license_at = [start, end];
            },
          },
          {
            text: "上周",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay() - 7
              );
              start.setHours(0, 0, 0);
              const end = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() - currentDate.getDay() - 1
              );
              end.setHours(23, 59, 59);
              this.searchArr.license_at = [start, end];
            },
          },
          {
            text: "本月",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                1
              );
              start.setHours(0, 0, 0);
              const end = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth() + 1,
                0
              );
              end.setHours(23, 59, 59);
              this.searchArr.license_at = [start, end];
            },
          },
          {
            text: "上月",
            onClick: () => {
              const currentDate = new Date();
              const start = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth() - 1,
                1
              );
              start.setHours(0, 0, 0);
              const end = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
              end.setHours(23, 59, 59);
              this.searchArr.license_at = [start, end];
            },
          },
        ],
      },
      companies: [],
      loading: true,
      callLogsDrawer: false,
      company: "",
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      orderInfoVisible: false,
      orderInfoId: null,
      msgTemplate: [],
      fileLists: [],
      overFileLists: [],
      needUrl: [],
      editNeedUrl: [],
      overNeedUrl: [],
      change: false,
      overChange: false,
      limit: 10,
      fromOptions: [],
      flow_tax: [],
      bindId: null,
      bindcLoading: false,
      bindCompanyOptions: [],
      bindTaxNumberDialogVisible: false,
      companyInfoDrawer: false,
      companyInfoId: null,
      // 合同详情
      contractDetailDrawer: false,
      singleContract: {},
      // 流水号详情
      flowDetailDrawer: false,
      invoiceOpenDrawer: false,
      // 公司下的发票号
      companyInvoiceData: [],
      multipleSelection: [],
      orderDetailDate: [],
      showType: 0,
      // 支付宝推广订单
      alipayOrderSyncDrawer: false,
      alipayOrder: {
        keyString: "",
        syncDate: "",
      },
      currentTime: "",
      systemOverOrderDrawer: false,
      systemOverOrderData: {
        id: null,
        feedback: "",
      },
      // 申请退款弹窗
      applyRefundOrderDrawer: false,
      applyRefundOrderFeedback: {
        refundable: "",
        reason_for_return: "",
        refund_priority: "",
        feedback_source: "",
        feedback: "",
        order_id: "",
        is_init_refund: 1,
        receive_bank: "",
        receive_card_no: "",
        receive_card_acc: "",
        return_money: 1,
      },
      orderMoney: 0,
      searchSingleProvince: [],
      searchSingleCity: [],
      batchTag: false,
      currentTel: "",
      linkOrderDrawer: false,
      customerBelongs: [],
      picList: [],
      lookReceiveVoucherDialog: false,
      activitiesShow: [],
      flowNumber: "",
      hasCompanyState: false,
      serviceProvider: [],
      place_parks: [],
      roleAuth: [],
      additionalData: { value: "自助下单", label: "自助下单" },
      selectedColumns: [],
      fields: [
        { id: "order_reg_name", name: "订单类型", fixed: false },
        { id: "order_status", name: "订单状态", fixed: false },
        { id: "convert", name: "转化人员", fixed: false },
        { id: "advisor", name: "沟通专员(业务)", fixed: false },
        { id: "chat_status", name: "沟通状态", fixed: false },
        { id: "operator_name", name: "服务人员", fixed: false },
        { id: "service_status", name: "服务状态", fixed: false },
        { id: "company_name", name: "公司名称", fixed: false },
        { id: "total_amount", name: "订单金额", fixed: false },
        { id: "source_name", name: "客户来源", fixed: false },
        { id: "customer_name", name: "客户姓名", fixed: false },
        { id: "customer_phone", name: "客户手机", fixed: false },
        { id: "customer_belongs", name: "客户隶属", fixed: false },
      ],
      checked: false,
      special_checked: false,
      rowSelected: '',
      colSelected: ''
    };
  },
  computed: {
    personnelConvert() {
      return [this.additionalData, ...this.personnel];
    },
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
    showMealSingles() {
      return this.containsAny(this.addForm.mealSingles, [1, 11, 41, 43, 52, 53]);
    },
    isOrderRegTypeInclueded() {
      const validOrderRegTypes = [11, 12, 13, 9, 10, 7, 6, 2];
      return validOrderRegTypes.includes(this.addForm.order_reg_type);
    }
  },
  methods: {
    handleExportFlash() {
      this.$axios.post('api/api3/tyc_order/export_flash', this.searchStr, { responseType: 'blob' }).then(({ data }) => {
        // 创建一个新的URL代表指定的File对象或Blob对象
        const url = window.URL.createObjectURL(new Blob([data]));
        // 创建一个a标签用于触发下载
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '订单列表.csv');
        document.body.appendChild(link);
        link.click();
        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }).catch()
    },
    handleMoneyinChange(val) {
      if (val === 18) {
        this.addForm.pay_moment = ''
        this.fileLists = [];
        this.needUrl = [];
      }
    },
    handleDateChanged(val) {
      this.addForm.pay_moment = val
    },
    handleVisibleChange(visible, field) {
      const refMap = {
        'money_in': {
          inputRef: 'cascaderInput',
          callback: this.loadMoneyInCate
        },
        'order_from': {
          inputRef: 'cascaderOrderFromInput',
          callback: this.getFrom
        },
        'customer_source': {
          inputRef: 'cascaderCustomerSourceInput',
          callback: this.getSources
        },
      };

      const { inputRef, callback } = refMap[field];
      if (visible) {
        const cascaderInput = this.$refs[inputRef];
        if (cascaderInput && cascaderInput.$refs.input) {
          cascaderInput.$refs.input.focus();
        }
        this.$nextTick(callback);
      }
    },
    handleControl() {
      this.addForm.gifts_length = '';
    },
    containsAny(array, values) {
      return array.some((item) => values.includes(item));
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector(".el-collapse");
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = "";
      }
    },
    handleImportSharer(res) {
      if (res.code === 0) {
        console.log(res);
      } else {
        this.$message.error(res.msg);
      }
    },
    changeHasCompany(e) {
      this.hasCompanyState = e;
    },
    enter(id) {
      this.$axios.get("/api/admin/get_reflect_record?id=" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.reflectFormatRecord(id, data.data.reflectRecord);
        }
      });
    },
    generateOrderNum() {
      // 生成随机订单编号的方法
      const characters = "ABCDEFGHIJKLMNOPQRSTUVWSYZ0123456789";
      const length = 8;
      let result = "";
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      this.addForm.order_num = result;
    },
    handleLinkImgS(indexs, index) {
      var tempwindow = window.open("_blank");
      tempwindow.location = this.activitiesShow[index].images[indexs].url;
    },
    reflectFormatRecord(id, data) {
      for (var i = 0; i < this.pageData.length; i++) {
        if (id === this.pageData[i].id) {
          this.activitiesShow = data;

          for (var a = 0; a < this.activitiesShow.length; a++) {
            if (this.activitiesShow[a].contact_type === "电话联系") {
              let duration =
                data[a].contact_duration === null ? " " : data[a].contact_duration;
              this.activitiesShow[a].contact_type =
                "通过 " + data[a].contact_type + "与客户沟通了" + duration + "秒";
            } else {
              this.activitiesShow[a].contact_type =
                "通过 " + data[a].contact_type + "与客户进行了沟通";
            }
            if (data[a].images) {
              this.activitiesShow[a].images = data[a].images;
            }
            this.activitiesShow[a].size = "large";
            this.activitiesShow[a].type = "primary";
            this.activitiesShow[a].icon = "el-icon-s-custom";
          }
        }
      }
    },
    success() {
      this.bindWeChatDrawer = false;
      this.handelGetOrders();
    },
    handleClose_weChatDrawer(done) {
      this.OrderNum = "";
      done();
    },
    openBindWeChatDrawer(row) {
      this.bindWeChatDrawer = true;
      this.$nextTick(() => {
        this.OrderNum = row.order_num;
      });
    },
    switchTime(dateTime) {
      const timestamp = new Date(dateTime).getTime() / 1000;
      return Math.floor(timestamp);
    },
    // 列表查看收款凭证
    lookReceiveVoucher(picList) {
      this.lookReceiveVoucherDialog = true;
      this.picList = picList;
    },
    // 订单录入  获取相关订单
    getLinkedOrder(inputTel) {
      if (inputTel === "") {
        this.$message.error("请输入手机号后在操作！");
        return;
      }
      this.linkOrderDrawer = true;
      setTimeout(() => {
        this.currentTel = inputTel;
      });
    },
    resetSomeValue() {
      this.addForm.is_renew = "否";
      this.addForm.company_id = null;
      this.addForm.mealSingles = [];
      this.addForm.flow_tax = "";
    },
    updatePhoneFrom() {
      this.updatePhoneFromDialog = true;
    },
    startBatchUpdateTelsp() {
      if (!this.batchUpdate.telsp) {
        this.$message.error("请选择批量处理手机号码归属地的时间范围!");
        return false;
      }
      if (!this.batchUpdate.data_table) {
        this.$message.error("请选择要处理的数据表!");
        return false;
      }
      this.$axios
        .post("api/admin/tyc_order/batch_update_tel_lsp", this.batchUpdate)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.updatePhoneFromDialog = false;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    // 支付宝订单退款
    alipayRefundOrder(index, row) {
      this.$confirm("是否确定直接退款?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/api/qyh/tyc_order/alipay_refund", {
              order_num: row.order_num,
            })
            .then((res) => {
              let { data } = res;
              if (data.code === 0) {
                this.handelGetOrders();
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            });
        })
        .catch(() => { });
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    handleWxChatOpen(chat, orderId) {
      if (chat) {
        this.$axios
          .get("/api/admin/tyc_order/company_name?orderId=" + orderId)
          .then((res) => {
            const { data } = res;
            if (data.code === 0) {
              this.wxChatDrawer = true;
              setTimeout(() => {
                this.wxWorkChatId = chat.chat_id;
                this.wxWorkchatCompany = data.data.chatName;
              });
            }
          });
      }
    },
    // 撤回退款申请
    handelRefundReturnSubmit(index, row) {
      this.$confirm("确定要撤回申请吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/api/admin/refund/return", { id: row.id })
            .then((res) => {
              const { data } = res;
              if (data.code === 0) {
                this.handelGetOrders();
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 系统结单
    systemOverOrder(index, row) {
      this.systemOverOrderDrawer = true;
      this.systemOverOrderData.id = row.id;
    },
    submitSystemOverOrder() {
      if (!this.systemOverOrderData.feedback) {
        this.$message.error("请填写结单理由!");
        return false;
      }
      if (!this.overNeedUrl.length) {
        this.$message.warning("请上传结单凭证!");
        return false;
      }
      this.systemOverOrderData.file = this.overNeedUrl;
      this.$axios
        .post("api/admin/tyc_order/system_order", this.systemOverOrderData)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.systemOverOrderDrawer = false;
            this.systemOverOrderData.feedback = "";
            this.overNeedUrl = [];
            this.handelGetOrders();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    // 申请退款
    applyRefundOrder(index, row) {
      this.applyRefundOrderDrawer = true;
      this.applyRefundOrderFeedback.order_id = row.id;
      this.orderMoney = row.total_amount;
    },
    // 提交申请退款
    submitApplyRefundOrder() {
      if (!this.applyRefundOrderFeedback.refundable) {
        this.$message.error("请选择是否可退款~");
        return;
      }
      if (
        this.applyRefundOrderFeedback.refundable === "部分退款" &&
        this.applyRefundOrderFeedback.return_money <= 0
      ) {
        this.$message.error("部分退款金额不能小于1");
        return;
      }
      if (
        this.applyRefundOrderFeedback.refundable === "部分退款" &&
        Number(this.applyRefundOrderFeedback.return_money) > this.orderMoney
      ) {
        this.$message.error("部分退款金额不能大于订单金额！");
        return;
      }
      if (!this.applyRefundOrderFeedback.reason_for_return) {
        this.$message.error("请选择退款原因~");
        return;
      }
      if (!this.applyRefundOrderFeedback.refund_priority) {
        this.$message.error("请选择退款优先级~");
        return;
      }
      if (
        !this.applyRefundOrderFeedback.is_init_refund === "0" &&
        !this.applyRefundOrderFeedback.receive_bank
      ) {
        this.$message.error("请填写收款银行~");
        return;
      }
      if (
        !this.applyRefundOrderFeedback.is_init_refund === "0" &&
        !this.applyRefundOrderFeedback.receive_card_no
      ) {
        this.$message.error("请填写收款银行卡号~");
        return;
      }
      if (
        !this.applyRefundOrderFeedback.is_init_refund === "0" &&
        !this.applyRefundOrderFeedback.receive_card_acc
      ) {
        this.$message.error("请填写收款银行账户~");
        return;
      }
      if (!this.applyRefundOrderFeedback.feedback_source) {
        this.$message.error("请选择反馈来源~");
        return;
      }
      if (!this.applyRefundOrderFeedback.feedback) {
        this.$message.error("请输入退款原因叙述~");
        return;
      }
      this.$axios
        .post("api/admin/tyc_order/apply_refund_order", {
          data: this.applyRefundOrderFeedback,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.applyRefundOrderDrawer = false;
            this.handelGetOrders();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleSelectionChange(val) {
      this.hugeData = val;
    },
    hugeAssign() {
      if (this.hugeData.length === 0) {
        this.$message.warning("请先勾选或全选条目!");
        return false;
      }
      this.hugeSign = true;
      this.batchTag = true;
      this.operatorVisible = true;
    },
    handleUpdateComSaler() {
      if (this.searchArr.orderRegType.length <= 0) {
        this.$message.warning("请选择除单品以外的订单类型!");
        return false;
      }
      if (!this.searchArr.service_status || this.searchArr.service_status != 4) {
        this.$message.warning("请选择服务状态并且服务状态是已完成!");
        return false;
      }
      if (this.hugeData.length === 0) {
        this.$message.warning("请勾选或全选条目!");
        return false;
      }
      this.$axios
        .post("api/admin/tyc_order/batch_replace_com_saler", {
          params: {
            ids: this.hugeData,
            order_types: this.searchArr.orderRegType,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            // this.handelGetOrders()
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    openPhoneFromDraw(phone) {
      // console.log(phone)
      // if (!this.hasDecryptPhonePower) {
      //   this.$message.warning("暂无权限查看,请先联系管理员!");
      //   return false;
      // }
      setTimeout(() => {
        this.phoneFrom_phone.push(phone);
      });
      this.phoneFromDraw = true;
    },
    makePhone(phone) {
      // 注释勿删,将来可能要恢复。
      // let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      // if (!regPhone.test(phone)) {
      //   this.$message.error('手机号格式错误')
      //   return
      // }

      if (!phone) {
        this.$message.error("手机号格式错误");
        return;
      }

      // this.$axios.post('/api/admin/call_logs/' + phone).then((res) => {
      this.$axios
        .post("api/admin/call_logs_call", {
          phone,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success("调用成功，请注意接听来电");
          } else {
            this.$message.error(data.msg);
          }
        });
      //   this.$axios
      //     .post("/api/admin/call_logs_new", {
      //       num: phone,
      //     })
      //     .then((res) => {
      //       let { data } = res;
      //       if (data.code === 0) {
      //         this.$message.success("调用成功，请注意接听来电");
      //       } else {
      //         this.$message.error(data.msg);
      //       }
      //     });
    },
    // 支付宝推广订单数据获取
    alipayOrderSync() {
      this.alipayOrderSyncDrawer = true;
    },
    // 开始获取
    submitStartSyncOrder() {
      if (!this.alipayOrder.keyString) {
        this.$message.error("请输入请求信息串！");
        return;
      }
      if (!this.alipayOrder.syncDate) {
        this.$message.error("请选择同步的日期！");
        return;
      }
      this.$axios
        .post("api/tyc_order/fetch_alipay_order", { data: this.alipayOrder })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.alipayOrderSyncDrawer = false;
            this.handelGetOrders();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    // 多选
    // handleSelectChange(val) {
    //   let incoiceNums = val.map((i) => {
    //     return i.incoice_num;
    //   });
    //   this.multipleSelection = incoiceNums;
    // },
    handleSelectChange(val) {
      let incoiceNums = val.map((i) => {
        return i.id;
      });
      this.multipleSelection = incoiceNums;
    },
    // 关联发票号
    handInvoiceNoOpen(row, id, company, type) {
      if (company === null) {
        this.$message.error("请先绑定公司后再操作！");
        return false;
      }

      this.special_checked = false
      this.checked = row.not_invoiced == 1 ? true : false
      let specialData = [];
      // 根据公司名称  获取对应的发票号
      this.$axios
        .get("api/tyc_order/get_invoice_company", {
          params: {
            companyName: company,
            type,
            id,
            is_special: row.is_special
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.companyInvoiceData = data.data.invoiceNoData;
            this.bindId = id;
            specialData = data.data.specialData
          } else {
            this.$message.error(data.msg);
          }
          this.orderDetailDate = [row, ...specialData];
        });
      this.showType = type;
      this.invoiceOpenDrawer = true;
    },
    handleInvoiceDialogClose() {
      this.orderDetailDate = []
      this.showType = 0
    },
    // 查看流水号记录
    handLookFlowRecord(flowNo) {
      this.flowDetailDrawer = true;
      setTimeout(() => {
        this.flowNumber = flowNo;
      }, 100);
    },
    // 查看合同详情
    handLookContractOpen(contractId) {
      this.contractDetailDrawer = true;
      this.$axios
        .get("api/tyc_order/get_contract_detail", {
          params: {
            id: contractId,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.singleContract = data.data.singleContract;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handCompanyOpen(cid) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyInfoId = cid;
      });
    },
    handleCompanyInfoBeforeClose(done) {
      this.companyInfoId = null;
      done();
    },
    // 绑定税号
    handBindTaxNumberOpen(row) {
      console.log(row)
      this.bindId = row.id;
      if (row.receipt_pic) {
        for (let i = 0; i < row.receipt_pic.length; i++) {
          this.evidenceUrlList.push({ url: row.receipt_pic[i].receive_url });
          this.bigPreviewList.push(row.receipt_pic[i].receive_url);
        }
      }
      this.flowdata.company_name =
        row.company_obj != null ? row.company_obj.company_name : "";
      this.flowdata.total_amount = row.total_amount;
      this.flowdata.money_in = row.money_in ? row.money_in.category_name : "";
      this.bindTaxNumberDialogVisible = true;
    },
    clearUrl() {
      this.evidenceUrlList = [];
      this.flowdata.company_name = "";
      this.flowdata.total_amount = 0;
      this.flowdata.money_in = "";
      this.bindId = null;
    },
    doBindTaxNumber() {
      if (this.remote.texNumber === "") {
        this.$message.error("未输入流水编号！");
        return false;
      }
      this.$axios
        .get("api/tyc_order/bind_tax_number", {
          params: {
            id: this.bindId,
            texNumber: this.remote.texNumber,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.bindTaxNumberDialogVisible = false;
            this.remote.texNumber = null;
            this.bindId = null;
            this.handelGetOrders();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    // 绑定发票号
    doBindInvoiceNo() {
      if (this.multipleSelection.length <= 0) {
        this.$message.error("未选择发票号！");
        return false;
      }
      this.$axios
        .post("api/tyc_order/bind_invoice_no", {
          params: {
            id: this.bindId,
            invoiceNo: this.multipleSelection,
            special_checked: this.special_checked
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.invoiceOpenDrawer = false;
            this.remote.invoiceNo = null;
            this.bindId = null;
            this.handelGetOrders();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    // 绑定公司
    handBindCompanyOpen(id) {
      this.bindCompanyDialogVisible = true;
      this.bindId = id;
    },
    companyBindRemote(query) {
      if (query !== "") {
        this.bindcLoading = true;
        this.companyBindSearch(query);
        setTimeout(() => {
          this.bindcLoading = false;
        }, 200);
      } else {
        this.bindCompanyOptions = [];
      }
    },
    companyBindSearch(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.bindCompanyOptions = data.data.companies;
        }
      });
    },
    doBind() {
      if (this.remote.company_id === "") {
        this.$message.error("未选取公司！");
        return false;
      }
      this.$axios
        .get("api/tyc_order/bindcompany", {
          params: {
            id: this.bindId,
            company_id: this.remote.company_id,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.bindCompanyDialogVisible = false;
            this.remote.company_id = null;
            this.bindId = null;
            this.handelGetOrders();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    // 获取公司流水编号
    handleChangeCompany(value) {
      if (typeof value === "string" && value.trim().length === 0) {
        this.clearAddLoadingData();
        return;
      }
      this.$axios
        .post("/api/admin/tyc_orders/get_com_tax_record", { value: value })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            console.log(data);
            this.flow_tax = data.data.flow_tax_records;

            if (data.data.company.fin_reg) {
              this.addServer.is_zero = data.data.company.fin_reg.is_zero_declare;
              this.addServer.begin_time =
                data.data.company.fin_reg.begin_time != null
                  ? data.data.company.fin_reg.begin_time
                  : "";
              // 服务时间
              const stime =
                data.data.company.fin_reg.start_time != null
                  ? data.data.company.fin_reg.start_time
                  : "";
              const etime =
                data.data.company.fin_reg.end_time != null
                  ? data.data.company.fin_reg.end_time
                  : "";
              this.addForm.server_time.push(stime, etime);
              this.addForm.include_gifts = data.data.company.fin_reg.include_gifts;
              this.addForm.gifts_length = data.data.company.fin_reg.gifts_length;
            }
            if (data.data.company.com_fiscal_tax) {
              this.addServer.take_money_rule =
                data.data.company.com_fiscal_tax.fin_charges;
            } else {
              this.addServer.take_money_rule = "";
            }
            if (data.data.company) {
              this.addServer.take_money_rule_real = data.data.company.real_price;
            }
            this.saveForm.flow_tax = "";
          } else {
            this.addForm.flow_tax = "";
            this.saveForm.flow_tax = "";
          }
        });
    },
    clearAddLoadingData() {
      this.addForm.server_time = [];
      this.addForm.include_gifts = false;
      this.addForm.gifts_length = "";
      this.addServer.take_money_rule = "";
      this.addServer.take_money_rule_real = [];
      this.addServer.begin_time = "";
      this.addServer.is_zero = "";
    },
    handleClose_memberInfoDrawer(done) {
      this.memberPhone = null;
      done();
    },
    openMemberInfoDrawer(phone) {
      this.memberInfoDrawer = true;
      setTimeout(() => {
        this.memberPhone = phone;
      }, 0);
    },
    loadMoneyInCate() {
      this.$axios
        .get("api/admin/moneyin/get_tree_data")
        .then(({ data }) => {
          if (data.code === 1) {
            this.moneyInCateOptions = data.data;
          }
        })
        .catch();
    },
    handleGetOrders1() {
      this.$axios.get(`${this.hyperfHost}/tyc_order_list`).then().cathc();
    },
    handelGetOrders() {
      this.$axios
        .get(
          "/api/admin/tyc_orders?page=" +
          this.pageOption.currentPage +
          "&pageSize=" +
          this.pageOption.pageSize +
          this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageNodes = data.data.pageNodes;
            this.pageData = data.data.orders.data;
            this.pageOption.total = data.data.orders.total;
            this.roleAuth = data.data.roleAuth;
            this.orderNumChange = false;
          }
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    handleGetCounts() {
      this.$axios
        .get("/api/admin/tyc_order/counts", { loadingClose: true })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.personnel = data.data.personnel;
            this.orderRegs = data.data.orderRegs; // 订单类型

            this.regTypes = data.data.regTypes;
            this.citys = data.data.cities;
            this.meals = data.data.meals;
            this.mealSingles = data.data.mealSingles;
            this.causes = data.data.causes;
            this.sources = data.data.sources;
            this.place_parks = data.data.placeParks;
            this.customerBelongs = data.data.customerBelongs;
            this.selectedColumns = [];
            if (data.data.fixed_columns && data.data.fixed_columns.length > 0) {
              this.selectedColumns = data.data.fixed_columns;
            }
          }
        });
    },
    handleASearSub() {
      this.pageOption.currentPage = 1;
      this.activeOpen = "";
      this.handelGetOrders();
    },
    handleASearClear() {
      this.searchArr.orderNum = "";
      this.searchArr.order_status = "";
      this.searchArr.chat_status = "";
      this.searchArr.service_status = "";
      this.searchArr.consultant = "";
      this.searchArr.convert = "";
      this.searchArr.orderRegType = [];
      this.searchArr.orderDate = "";
      this.searchArr.refund_date = "";
      this.searchArr.reason_for_return = null;
      this.searchArr.order_park = null;
      this.searchArr.workOrder = null;
      this.searchArr.contact_time = [];
      this.searchArr.license_at = [];
      this.searchArr.established_at = [];
      this.searchArr.next_contact_time = [];
      this.searchArr.timeOut = null;
      this.searchArr.operator = null;
      this.searchArr.mealSingles = [];
      this.searchArr.sources = null;
      this.searchArr.platform = null;
      this.searchArr.is_renew = null;
      this.searchArr.is_old_cus_out = "";
      this.pageOption.currentPage = 1;
      this.searchArr.is_member = null;
      this.searchArr.moneyin = [];
      this.searchArr.is_check_account = null;
      this.searchArr.is_open_ticket = null;
      this.searchArr.not_invoiced = '';
      this.searchArr.is_bind_company = null;
      this.searchArr.is_bind_client = null;
      this.searchArr.is_sign_contract = null;
      this.searchArr.pro = "";
      this.searchArr.city = "";
      this.searchArr.UlFailReason = "";
      this.searchArr.customer_belongs = null;
      this.searchArr.is_bind_we_group = null;
      this.searchArr.assign_chater_time = "";
      this.searchArr.sharer = [];
      this.activeOpen = "";
      this.handelGetOrders();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handelGetOrders();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetOrders();
    },
    handleExport() {
      if (this.pageData.length === 0) {
        this.$message.error("没有数据");
        return;
      }

      this.$axios
        .post(
          "/api/admin/tyc_order/download",
          { searchArr: this.searchArr, total: this.pageOption.total },
          { responseType: "blob" }
        )
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          let myDate = new Date();
          link.href = objectUrl;
          link.download = "订单" + myDate.toLocaleDateString() + ".xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 100);
          this.needSearchStr = "";
        });
    },
    handleExportDetail1() {
      if (!this.needSearchStr) return false;
      if (this.pageData.length === 0) {
        this.$message.error("没有数据");
        return;
      }
      this.$axios
        .post(
          "/api/admin/tyc_order/download_detail",
          this.needSearchStr,
          { total: this.pageOption.total },
          { responseType: "blob" }
        )
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          let myDate = new Date();
          link.href = objectUrl;
          link.download = "订单详情" + myDate.toLocaleDateString() + ".xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 100);
          this.needSearchStr = "";
        });
    },
    handleExportDetail() {
      if (this.pageData.length === 0) {
        this.$message.error("没有数据");
        return;
      }

      this.$axios
        .post(
          "/api/admin/tyc_order/download_detail",
          { searchArr: this.searchArr, total: this.pageOption.total },
          { responseType: "blob" }
        )
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          let myDate = new Date();
          link.href = objectUrl;
          link.download = "订单详情" + myDate.toLocaleDateString() + ".xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 100);
          this.needSearchStr = "";
        });
    },
    handleSourcesExport() {
      if (this.pageData.length === 0) {
        this.$message.error("没有数据");
        return;
      }
      this.$axios
        .post(
          "/api/admin/tyc_order/sourcesExport",
          { searchArr: this.searchArr },
          { responseType: "blob" }
        )
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          let myDate = new Date();
          link.href = objectUrl;
          link.download = "订单来源" + myDate.toLocaleDateString() + ".xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 100);
        });
    },
    handleScheduleExport() {
      if (this.pageData.length === 0) {
        this.$message.error("没有数据");
        return;
      }
      this.$axios
        .post("/api/admin/tyc_order/scheduleExport", {}, { responseType: "blob" })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          let myDate = new Date();
          link.href = objectUrl;
          link.download = "服务进度订单" + myDate.toLocaleDateString() + ".xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 100);
        });
    },
    handelDownload() {
      window.location.href = "http://wx.qyh.com/api/admin/tyc_order/download";
    },
    handleLogOpen(index, id) {
      this.$axios.get("/api/admin/tyc_orders/log/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.logs = data.data.logs;
          this.reflects = data.data.reflects;
          this.setSchedule(data.data.reflects);
          this.workOrders = data.data.workOrders;
          this.reflectForm.index = index;
          this.reflectForm.id = id;
          this.workNotCount = this.pageData[index].work_orders_count;
          this.groups = data.data.groups;
          this.groupName = data.data.groupName;
          this.chats = data.data.chats;
          this.relationOrders = data.data.relationOrders;
          this.relationCount = data.data.relationOrders.length;
          this.countFulfill(data.data.relationOrders);
          this.setOrderContent(index);
          this.orderItems = data.data.items;
          this.orderSources = this.pageData[index].source
            ? this.pageData[index].source.source_name
            : "";
          this.logDrawerCompanyName = data.data.tycOrder.company;
          this.logDrawer = true;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handelAssign(index, row) {
      this.$axios.put("/api/admin/tyc_orders/assign/" + row.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.handelGetOrders();
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleAddOpen() {
      this.addDrawer = true;
      this.orderRegTypes = [];
      this.serviceProvider = [];
      this.addForm.assign_at = this.getCurrentTime();
    },
    handleAddDrawerBeforeClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearAddData();
          done();
        })
        .catch((_) => { });
    },
    handleAddDrawerClose() {
      this.addDrawer = false;
      this.clearAddData();
    },
    clearAddData() {
      this.addForm.order_park = 1;
      this.addForm.platform = "";
      this.addForm.order_num = "";
      this.addForm.total_amount = 0;
      this.addForm.customer_name = "";
      this.addForm.customer_phone = "";
      this.addForm.assign_at = "";
      this.addForm.order_cate = null;
      this.orderRegTypes = [];
      this.addForm.order_reg_type = null;
      this.addForm.convert = "";
      this.addForm.is_renew = "否";
      this.addForm.company_id = null;
      this.addForm.mealSingles = [];
      this.addForm.moneyin = "";
      this.addForm.file = [];
      this.addForm.customer_belongs = "1";
      this.addForm.server_time = [];
      this.addForm.include_gifts = false;
      this.addForm.gifts_length = "";
      this.addForm.has_company = false;
      this.addForm.bind_order_num = "";
      this.addForm.service_business = "企业火";
      this.serviceProvider = [];
      this.addServer.take_money_rule = "";
      this.addServer.take_money_rule_real = [];
      this.addServer.begin_time = "";
      this.addServer.is_zero = "";
      this.fileLists = [];
      this.needUrl = [];
      this.addForm.pay_moment = ''
    },
    handleSave() {
      if (!this.addForm.platform) {
        this.$message.error("请选择订单来源！");
        return;
      }
      if (!this.addForm.order_num) {
        this.$message.error("订单编号不能为空！");
        return;
      }
      if (this.addForm.is_renew === "是" && this.addForm.order_reg_type === 3) {
        this.$message.error("续费订单时，订单类型不能为云上公司注册！");
        return;
      }
      if (
        this.addForm.order_cate !== 1 &&
        this.addForm.has_company === false &&
        !this.addForm.company_id
      ) {
        this.$message.error("请填写服务公司！");
        return;
      }
      if (!this.addForm.customer_phone) {
        this.$message.error("客户手机不能为空！");
        return;
      }
      // if (this.addForm.is_renew === "是" && !this.addForm.bind_order_num) {
      //   this.$message.error("续费状态下，请绑定订单号！");
      //   return;
      // }
      if (!/^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(this.addForm.total_amount)) {
        this.$message.error("订单金额类型错误！");
        return;
      }
      if (!this.addForm.moneyin) {
        this.$message.error("请选择收款方式！");
        return;
      }
      if (this.addForm.moneyin != 18 && !this.needUrl.length) {
        this.$message.warning("请上传收款凭证!");
        return;
      }
      if (this.addForm.moneyin != 18 && !this.addForm.pay_moment) {
        this.$message.warning("请填写支付时间!");
        return;
      }

      this.addForm.file = this.needUrl;
      this.$axios.post("/api/admin/tyc_orders", this.addForm).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.handelGetOrders();
          this.handleAddDrawerClose();
          if (data.data.isExists) {
            this.$alert("订单录入成功，该手机号已关联多个云上注册订单，请留意", "提醒", {
              confirmButtonText: "确定",
            });
          } else {
            this.$message.success(data.msg);
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleEditOpen(index, row) {
      this.upDrawer = true;
      this.$nextTick(() => {
        this.saveForm.id = row.id;
        this.saveForm.order_num = row.order_num;
      })

      // console.log(row);
      // this.saveForm.editFileLists = []; // 初始化收款凭证
      // this.saveForm.index = index;
      // this.saveForm.order_num = row.order_num;
      // this.saveForm.assign_at = row.assign_at;
      // this.saveForm.reason_for_return = row.refund_cause_id;
      // this.saveForm.reason_for_return_info = row.reason_for_return_info;
      // this.saveForm.refund_date = row.refund_date;
      // this.saveForm.mealSingles = this.getSingleIds(row.meal_singles);

      // if (row.advisor) {
      //   this.saveForm.consultant.push(row.advisor.branch_id, row.advisor.id);
      // }
      // if (row.trans) {
      //   this.saveForm.convert.push(row.trans.branch_id, row.trans.id);
      // } else {
      //   this.saveForm.convert.push(this.additionalData);
      // }
      // if (row.operator) {
      //   this.saveForm.operator.push(row.operator.branch_id, row.operator.id);
      // }

      // this.saveForm.total_amount = row.total_amount;
      // this.saveForm.customer_name = row.customer_name;
      // this.saveForm.customer_belongs = row.customer_belongs;
      // this.saveForm.refundable = row.refundable;
      // this.getOrderCate(row.order_reg_type);
      // this.saveForm.order_reg_type = row.order_reg_type;
      // this.saveForm.refund_priority = row.refund_priority;
      // this.saveForm.feedback_source = row.feedback_source;
      // this.saveForm.sources = row.sources;
      // this.saveForm.platform = row.platform;
      // this.saveForm.company = row.company;
      // this.saveForm.company_id = row.company_id;
      // this.saveForm.is_renew = row.is_renew;
      // if (row.money_in) {
      //   this.$nextTick(() => {
      //     this.loadMoneyInCate();
      //     this.saveForm.moneyin = row.money_in.id;
      //   });
      // } else {
      //   this.saveForm.moneyin = '';
      // }
      // this.saveForm.acc_discharge_no = row.acc_discharge_no;
      // this.saveForm.service_business = row.service_business;

      // if (row.company_id && row.company) {
      //   this.saveForm.companies.push({ id: row.company_id, company_name: row.company });
      // }
      // if (row.receipt_pic) {
      //   for (let i = 0; i < row.receipt_pic.length; i++) {
      //     this.saveForm.editFileLists.push({
      //       url: row.receipt_pic[i].receive_url,
      //       name: row.receipt_pic[i].name,
      //     });
      //   }
      // }
      // if (row.company_obj && row.company_obj.fin_table) {
      //   const start_time = row.company_obj.fin_table.start_time;
      //   const end_time = row.company_obj.fin_table.end_time;
      //   this.saveForm.server_time = [start_time, end_time];
      //   this.saveForm.include_gifts = row.company_obj.fin_table.include_gifts
      //   this.saveForm.gifts_length = row.company_obj.fin_table.gifts_length
      // }

    },
    handleDataUpdated() {
      this.upDrawer = false;
      this.handelGetOrders();
    },
    getOrderCate(order_reg_type) {
      this.$axios
        .get(
          "/api/admin/tyc_order/get_order_cate_by_order_type?order_reg_type=" +
          order_reg_type
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.saveOrderRegs = data.data.saveOrderRegs;
            this.saveForm.order_cate = data.data.order_cate;
          }
        });
    },
    getOrderRegType(cate_id, type) {
      this.addForm.order_reg_type = null;
      this.addForm.is_renew = "否";
      this.addForm.company_id = null;
      this.addForm.flow_tax = "";
      this.addForm.server_time = [];
      this.addForm.include_gifts = false;
      this.addForm.gifts_length = "";

      // this.saveForm.order_reg_type = null;
      // this.saveForm.is_renew = "否";
      // this.saveForm.company_id = null;
      // this.saveForm.flow_tax = "";
      // this.saveForm.mealSingles = [];

      this.$axios
        .post("/api/admin/tyc_order/get_order_reg_type_by_cate", { order_cate: cate_id })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            if (type === 0) {
              this.orderRegTypes = data.data.orderRegs;
            } else {
              this.saveOrderRegs = data.data.orderRegs;
            }
          }
        });
    },
    getSingleIds(arr) {
      let ids = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].item_id) {
          ids.push(arr[i].item_id);
        } else {
          ids.push(arr[i]);
        }
      }
      return ids;
    },
    oldCusOutShow() {
      let show = false;
      if (this.saveForm.mealSingles.indexOf(5) !== -1) show = true;
      if (this.saveForm.mealSingles.indexOf(7) !== -1) show = true;
      if (this.saveForm.mealSingles.indexOf(14) !== -1) show = true;

      return show;
    },
    handleUpdateClose(done) {
      this.clearUpdateData();
      done();
    },
    clearUpdateData() {
      this.saveForm.index = null;
      this.saveForm.id = 0;
      this.saveForm.order_num = "";
      this.saveForm.assign_at = "";
      this.saveForm.reason_for_return = null;
      this.saveForm.reason_for_return_info = "";
      this.saveForm.refund_date = "";
      this.saveForm.mealSingles = [];
      this.saveForm.consultant = [];
      this.saveForm.convert = [];
      this.saveForm.operator = [];
      this.operator = [];
      this.saveForm.total_amount = 0;
      this.saveForm.customer_name = "";
      this.saveForm.customer_belongs = null;
      this.saveForm.refundable = null;
      this.saveForm.order_cate = null;
      this.saveForm.order_reg_type = null;
      this.saveForm.refund_priority = "";
      this.saveForm.feedback_source = "";
      this.saveForm.company = "";
      this.saveForm.company_id = null;
      this.saveForm.is_renew = null;
      this.saveForm.moneyin = "";
      this.companies = [];
      this.saveForm.platform = "";
      this.saveForm.server_time = [];
      this.saveForm.include_gifts = false;
      this.saveForm.gifts_length = '';
    },
    handelSaveChange(field, fieldName) {
      // console.log(field, fieldName);return;
      let index = this.saveForm.index;
      let check = true;

      if (field === "total_amount") {
        check = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(this.saveForm[field]);
      }

      if (!check) {
        this.$message.error("订单金额类型错误");
        this.saveForm[field] = 0;
        return;
      }
      if (this.pageData[index][field] === this.saveForm[field]) return;

      this.$axios
        .put("/api/admin/tyc_orders/field/" + this.saveForm.id, {
          field: String(field),
          fieldName: fieldName,
          value: this.saveForm[field],
          old: this.pageData[index][field],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            // this.pageData[index][field] = this.saveForm[field];
            this.handelGetOrders();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    setPageDataMeal(mealSingles) {
      this.pageData[this.saveForm.index].meal_singles = [];
      for (let i = 0; i < mealSingles.length; i++) {
        for (let j = 0; j < this.mealSingles.length; j++) {
          if (mealSingles[i] === this.mealSingles[j].item_id) {
            this.pageData[this.saveForm.index].meal_singles.push({
              item_id: this.mealSingles[j].item_id,
              item_name: this.mealSingles[j].item_name,
            });
          }
        }
      }
    },

    // handelSavePeopleSel(field, fieldName, type) {
    //   console.log('field', field)
    //   console.log('fieldName', fieldName)
    //   console.log('type', type)
    //   console.log('this[type][field]', this[type][field]);   // 新

    //   let index = this[type].index;
    //   let name = this.getPeopleName(this[type][field]);
    //   let old = this.getPeopleName(this.pageData[index][field]);
    //   if (name === old) return;
    //   this.handelCommonSelChange(field, fieldName, type, index, name, old);
    // },
    handelSavePeopleSel(field, fieldName, type) {
      // console.log('field', field)
      // console.log('fieldName', fieldName)
      // console.log('type', type)
      // console.log('this[type][field]', this[type][field]);   // 新

      let index = this[type].index;

      // console.log(this.pageData[index]);return;

      let newId = this[type][field][1];
      let oldId =
        this.pageData[index][field] !== null ? this.pageData[index][field].id : null;

      if (newId === oldId) return;
      this.handelCommonSelChange(field, fieldName, type, index, newId, oldId);
    },
    handelCommonSelChange(field, fieldName, type, index, newId, oldId) {
      let params = {
        field: String(field),
        fieldName: fieldName,
        value: this[type][field],
        newId: newId,
        oldId: oldId,
      };
      this.$axios
        .put("/api/admin/tyc_orders/common_sel/" + this[type].id, params)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.handelGetOrders();
            this.upDrawer = false;
            this.clearUpdateData();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handelOrderRegTypeSel(field, fieldName, type) {
      let index = this[type].index;
      let name = this.getOrderRegTypeName(this[type][field]);
      let old = this.getOrderRegTypeName(this.pageData[index][field]);

      if (name === old) return;

      this.handelSelSub(field, fieldName, type, index, name, old);
    },
    getOrderRegTypeName(val) {
      let obj = {};
      let name = "";
      obj = this.saveOrderRegs.find((item) => {
        return item.order_reg_id === val;
      });
      if (obj) name = obj.order_reg_name;
      return name;
    },
    handelSourcesSel(field, fieldName, type) {
      let index = this[type].index;
      let name = this.getSourcesName(this[type][field]);
      let old = this.getSourcesName(this.pageData[index][field]);

      if (name === old) return;

      this.handelSelSub(field, fieldName, type, index, name, old);
    },
    getSourcesName(val) {
      let obj = {};
      let name = "";
      obj = this.sources.find((item) => {
        return item.source_id === val;
      });
      if (obj) name = obj.source_name;
      return name;
    },
    handelRegTypeSel(field, fieldName, type) {
      let index = this[type].index;
      let name = this.getRegTypeName(this[type][field]);
      let old = this.getRegTypeName(this.pageData[index][field]);

      if (name === old) return;

      this.handelSelSub(field, fieldName, type, index, name, old);
    },
    getRegTypeName(val) {
      let obj = {};
      let name = "";
      obj = this.regTypes.find((item) => {
        return item.reg_type_id === val;
      });
      if (obj) name = obj.reg_type_name;
      return name;
    },
    handelSelSub(field, fieldName, type, index, name, old) {
      let params = {
        field: String(field),
        fieldName: fieldName,
        value: this[type][field],
        nameStr: name,
        oldStr: old,
      };
      this.$axios
        .put("/api/admin/tyc_orders/sel/" + this[type].id, params)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData[index][field] = this[type][field];
            if (field === "order_reg_type") {
              this.pageData[index].order_reg = {
                order_reg_id: this[type][field],
                order_reg_name: name,
              };
            }
            if (field === "sources") {
              this.pageData[index].sources = this[type][field];
              this.pageData[index].source = {
                source_id: this[type][field],
                source_name: name,
              };
            }
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    // handelPeople(field, relatedField, fieldName, type) {
    //   let index = this[type].index;
    //   let name = this.getPeopleName(this[type][field]);
    //   let old = this.getPeopleName(this.pageData[index][field]);

    //   if (name === old) return;

    //   this.handelPeopleChange(field, relatedField, fieldName, type, index, name, old);
    // },
    // getPeopleName(val) {
    //   let obj = {};
    //   let name = "";
    //   obj = this.personnel.find((item) => {
    //     item.children.find((child) => {
    //       return child.value === val.id;
    //     })
    //   });

    //   if (obj) name = obj.username;
    //   return name;
    // },
    // handelPeopleChange(field, relatedField, fieldName, type, index, name, old) {
    //   let params = {
    //     field: String(field),
    //     relatedField: relatedField,
    //     fieldName: fieldName,
    //     value: this[type][field],
    //     name: name,
    //     old: old,
    //   };

    //   this.$axios
    //     .put("/api/admin/tyc_orders/people/" + this[type].id, params)
    //     .then((res) => {
    //       const { data } = res;
    //       if (data.code === 0) {
    //         this.pageData[index][field] = this[type][field];
    //         this.pageData[index][relatedField] = name;
    //         this.$message.success(data.msg);
    //       } else {
    //         this.$message.error(data.msg);
    //       }
    //     });
    // },
    getRefundNames(val) {
      let str = "";
      for (let i = 0; i < this.causes.length; i++) {
        if (val === this.causes[i].refund_id) {
          str = this.causes[i].refund_cause;
        }
      }

      return str;
    },
    handleImport(res, file) {
      if (res.code === 0) {
        this.$message.success(res.msg);
      }
    },
    handleOrderImportSuccess(res) {
      if (res.code === 1) {
        this.$message.success(`成功导入${res.data}条数据！`);
      }
    },
    handleRecord() {
      this.$axios.post("/api/admin/tyc/record").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.tableData.push(data.data);
          this.dialogVisible = true;
        }
      });
    },
    handelDialogClose(done) {
      this.tableData = [];
      done();
    },
    handleOpenAddWorkOrder() {
      if (!this.pageData[this.reflectForm.index].consultant) {
        this.$message.error("该订单没有顾问，请先分配顾问！");
        return;
      }
      this.addWorkOrderVisible = true;
    },
    handleAddWorkOrderClose(done) {
      this.$refs["workForm"].resetFields();
      done();
    },
    handleWorkSuccess(res, file) {
      if (res.code === 0) {
        this.workOrders[res.data.index].images.push(res.data);
      } else {
        this.$message.error(res.msg);
      }
    },
    handleWorkPreview(file) {
      let tempwindow = window.open("_blank");
      tempwindow.location = file.url;
    },
    getWorkIndex(imagetableTableId) {
      for (let i = 0; i < this.workOrders.length; i++) {
        if (this.workOrders[i].id === Number(imagetableTableId)) return i;
      }

      return false;
    },
    handleWorkRemove(file, fileList) {
      let index = this.getWorkIndex(file.imagetable_id);
      if (index === false) {
        this.$message.error("请求错误，清刷新重试");
        return;
      }

      this.$axios.post("/api/admin/tycImages/" + file.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.imageListDel(index, file.id);
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    imageListDel(index, imgId) {
      for (let i = 0; i < this.workOrders[index].images.length; i++) {
        if (this.workOrders[index].images[i].id === imgId) {
          this.workOrders[index].images.splice(i, 1);
        }
      }
    },
    fileChange(file, fileList) {
      this.uploadedList = fileList;
    },
    fileRemove(file, fileList) {
      this.uploadedList = fileList;
    },
    handleReflectPreview(file) {
      let tempwindow = window.open("_blank");
      tempwindow.location = file.url;
    },
    thisWeek() {
      let Nowdate = new Date();
      let WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);

      let M = Number(WeekFirstDay.getMonth()) + 1;
      let start = WeekFirstDay.getFullYear() + "-" + M + "-" + WeekFirstDay.getDate();

      let WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000);
      let Mon = Number(WeekLastDay.getMonth()) + 1;
      let end = WeekLastDay.getFullYear() + "-" + Mon + "-" + WeekLastDay.getDate();

      return [start, end];
    },
    prevWeek() {
      let end = new Date();
      let start = new Date();
      let lastWeek = new Date().getDay(); // 获取今日周几
      // 开始时间(上周一与今天间隔的天数)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1)); // 减1是因为以下时间戳操作,例如周二,但是时间戳还在周一后的xx小时
      // 结束时间(上周末与今天间隔的天数)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek);

      return [start, end];
    },
    today() {
      return [new Date(), new Date()];
    },
    yesterday() {
      let date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24);

      return [date, date];
    },
    thisMon() {
      let end = new Date();
      let start = new Date();
      // 方法1
      let endDay = new Date().getDate() - 1; // 获取今日几号,减1是因为以下时间戳操作,例如今日16号,但是时间戳还在15号后的xx小时
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay);
      // 方法2
      // start.setDate(1) //setDate(1)表示设置开始时间为本月1号,此办法同样可以实现
      return [start, end];
    },
    lastMon() {
      let end = new Date();
      let start = new Date();
      let year = new Date().getFullYear(); // 获取年份
      let month = new Date().getMonth(); // 获取月份
      month = month === 0 ? 1 : month; // 特殊处理:如果为1月 则下方取1月的天数
      let febDays = year % 4 ? 29 : 28; // 判断今年是否为闰年,如是则二月天数为29天,反之为28天
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 罗列12个月的天数
      start.setDate(1 - days[month - 1]); // setDate(1)表表示设置为本月1号,故 本月1号 - 上月天数 = 上月1号
      end.setDate(1 - 1); // 以此得出,本月1号 - 1天 = 上月最后一天

      return [start, end];
    },
    handleOpenOperator(index, id) {
      this.operatorIndex = index;
      this.operatorId = id;
      this.batchTag = false;
      this.operatorVisible = true;
    },
    handleOperatorClose(done) {
      this.operatorIndex = null;
      this.operatorId = null;
      this.hugeSign = false;
      done();
    },
    handleOperatorSave() {
      if (!this.operator && !this.communicator && !this.sharer) {
        this.$message.error("请选择批量分配的人员！");
        return;
      }
      if (this.hugeSign) {
        this.doHugeSign();
      } else {
        this.$axios
          .put("/api/admin/operator/" + this.operatorId, {
            operator: this.operator,
          })
          .then((res) => {
            const { data } = res;
            if (data.code === 0) {
              this.$message.success(data.msg);
              this.handelGetOrders();
              this.operatorIndex = null;
              this.operatorId = null;
              this.operator = [];
              this.operatorVisible = false;
            } else {
              this.$message.error(data.msg);
            }
          });
      }
    },
    doHugeSign() {
      if (this.operator.length <= 0 && this.communicator.length <= 0 && this.sharer.length <= 0) {
        this.$message.error("请选择批量分配的人员！");
        return;
      }
      this.$axios
        .put("api/tyc_order/huge_assign", {
          operator: this.operator,
          communicator: this.communicator,
          sharer: this.sharer,
          orders: this.hugeData,
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.hugeSign = false;
            this.batchTag = false;
            this.operatorVisible = false;
            this.operator = [];
            this.communicator = [];
            this.sharer = [];
            this.$message.success(data.msg);
            this.handelGetOrders();
          }
        })
        .catch();
    },
    copyUrl(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      });
      oInput.remove();
    },
    getMeals(meals) {
      let str = "";
      for (let i = 0; i < meals.length; i++) {
        str += meals[i].item_name;
        if (i < meals.length - 1) {
          str += "，";
        }
      }
      return str;
    },
    handleOrderNumChange(val) {
      if (this.orderNumChange) return;
      this.orderNumChange = true;
      setTimeout(() => {
        this.pageOption.currentPage = 1;
        this.handelGetOrders();
      }, 800);
    },
    remoteMethod(query) {
      if (query !== "") {
        // this.loading = true;
        setTimeout(() => {
          // this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleUpCompanyChange() {
      let oldName = this.saveForm.company;
      let newName = this.getCompanyName(this.saveForm.company_id);
      this.$axios
        .post("/api/admin/companyChange/" + this.saveForm.id, {
          oldName: oldName,
          newName: newName,
          changeId: this.saveForm.company_id,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.pageData[this.saveForm.index].company = newName;
            this.pageData[this.saveForm.index].company_id = this.saveForm.company_id;
            this.handleChangeCompany(this.saveForm.company_id);
          }
        });
    },
    getCompanyName(id) {
      let newName = null;
      for (let i = 0; i < this.companies.length; i++) {
        if (this.companies[i].id === id) {
          newName = this.companies[i].company_name;
        }
      }

      return newName;
    },
    handCallLogsOpen(row) {
      // if (!this.hasDecryptPhonePower) {
      //   this.$message.warning("暂无权限查看,请先联系管理员!");
      //   return false;
      // }
      this.callLogsDrawer = true;
      setTimeout(() => {
        this.company = row.company;
        // if (row.customer_phone) this.callPhone1.push(row.customer_phone)
        if (row.customer_phone_code) {
          this.callPhone1.push(row.customer_phone_code);
        } else {
          this.callPhone1.push(row.vagary_phone);
        }
        if (row.corporate_phone) this.callPhone2.push(row.corporate_phone);
        if (row.company_obj) {
          if (row.company_obj.docking_phone) {
            this.callPhone3.push(row.company_obj.docking_phone);
          }
          if (row.company_obj.user) {
            this.callPhone.push(row.company_obj.user.phone);
          }
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handlelinkOrderDrawerBeforeClose(done) {
      this.currentTel = "";
      done();
    },
    closePhoneFromDraw(done) {
      this.phoneFrom_phone = [];
      done();
    },
    handleOrderInfo(orderId, orderNum) {
      // if (!this.hasDecryptPhonePower) {
      //   this.$message.warning("暂无权限查看,请先联系管理员!");
      //   return false;
      // }
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = orderId;
        this.OrderNum = orderNum;
      });
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null;
      this.id = null;
      done();
    },
    changeOrder(id, contactTime) {
      for (let i = 0; i < this.pageData.length; i++) {
        if (this.pageData[i].id === id) {
          this.pageData[i].contact_time = contactTime;
        }
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片格式为JPG或PNG!')
        return
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid });
      }
    },

    overHandleAvatarSuccess(res, file) {
      console.log(res);
      if (res.code === 1) {
        this.overNeedUrl.push({ url: res.url, name: file.name, uid: file.uid });
      }
    },
    handleAvatarChange(res, file) {
      this.fileLists = file;
      this.change = true;
    },

    overHandleAvatarChange(res, file) {
      this.overFileLists = file;
      this.overChange = true;
    },
    handlePictureCardPreview(file) {
      this.addDialogVisible = true;
      this.addDialogImageUrl = file.url;
    },

    overHandlePictureCardPreview(file) {
      console.log(file);
      this.overDialogVisible = true;
      this.overDialogImageUrl = file.url;
    },
    handleRemoveR(file, fileList) {
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1);
        }
      });
      this.fileLists = fileList;
      this.change = true;
    },

    overHandleRemoveR(file, fileList) {
      this.overNeedUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.overNeedUrl.splice(index, 1);
        }
      });
      this.overFileLists = fileList;
      this.overChange = true;
    },
    // 监听粘贴操作
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        file = items[i].getAsFile();
      }
      if (this.fileLists.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`); // 图片数量超出
        return;
      }
      this.$refs.uploadMutiple.handleStart(file); // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit(); // 提交图片上传队列
    },

    overHandlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地！");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        file = items[i].getAsFile();
      }
      if (this.overFileLists.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`); // 图片数量超出
        return;
      }
      this.$refs.overUploadMutiple.handleStart(file); // 将粘贴过来的图片加入预上传队列
      this.$refs.overUploadMutiple.submit(); // 提交图片上传队列
    },
    getSources() {
      this.$axios
        .get("api/custom_source/get_source_tree")
        .then(({ data }) => {
          if (data.code === 1) {
            this.sources = data.data;
          }
        })
        .catch();
    },
    getFrom() {
      this.$axios
        .get("api/admin/other_orders/get_from_tree")
        .then(({ data }) => {
          if (data.code === 1) {
            this.fromOptions = data.data;
          }
        })
        .catch();
    },
    getServiceProvider() {
      this.$axios
        .get("api/admin/service_provider/get_service_provider")
        .then(({ data }) => {
          if (data.code === 0) {
            this.serviceProvider = data.data.serviceProvider;
          }
        })
        .catch();
    },
    checkedCustomerState(state) {
      if (state === true) {
        this.checkedCustomer = true;
      } else {
        this.checkedCustomer = false;
        this.clearSearchArrData();
      }
    },
    clearSearchArrData() {
      this.searchArr.established_at = [];
    },
    checkedOrderState(state) {
      if (state === true) {
        this.checkedOrder = true;
      } else {
        this.checkedOrder = false;
      }
    },
    checkedRefundState(state) {
      if (state === true) {
        this.checkedRefund = true;
      } else {
        this.checkedRefund = false;
      }
    },
    checkedOthersState(state) {
      if (state === true) {
        this.checkedOthers = true;
      } else {
        this.checkedOthers = false;
      }
    },
    // 远程搜索号码归属地
    remoteGetProvince(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchProvince(query);
        }, 200);
      } else {
        this.searchSingleProvince = [];
      }
    },
    searchProvince(query) {
      this.$axios
        .get("/api/admin/tel_isp/get_province_isp?keyword=" + query)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.searchSingleProvince = data.data.searchSingleProvince;
          }
        });
    },
    remoteGetCity(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCity(query);
        }, 200);
      } else {
        this.searchSingleCity = [];
      }
    },
    searchCity(query) {
      this.$axios.get("/api/admin/tel_isp/get_city_isp?keyword=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchSingleCity = data.data.searchSingleCity;
        }
      });
    },
    handleColumnSelectionChange(selectedColumns) {
      this.$axios
        .post("/api/admin/finance/set_fixed_column", {
          fields: this.selectedColumns,
          type: 2,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.fields.forEach((column) => {
              column.fixed = this.selectedColumns.includes(column.id);
            });
            this.$message.success(data.msg);
          }
        });
    },
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.orderInfoVisible = false;
      }
    },
    handleInvoiceCheck(checked) {
      this.$axios.post('/api/tyc_order/mark_not_invoiced', {
        id: this.bindId,
        checked
      }).then(({ data }) => {
        if (data.code == 200) {
          this.$message.success(data.msg)
          this.handelGetOrders()
          this.invoiceOpenDrawer = false
          // this.pageData.forEach(item => {
          //   if (item.id === this.bindId) {
          //     item.not_invoiced = checked ? 1 : null
          //   }
          // })
          this.$refs.multipleTable.clearSelection();
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    // 新增这个方法
    isSelectable(row) {
      return !this.checked;
    },
    getRowClassName({ row, rowIndex }) {
      return this.checked ? 'disabled-row' : '';
    },
    doEmitBindInvoiceNo(order_id) {
      // this.currentOrderData.forEach(item => {
      //   if (item.id == order_id) {
      //     item.invoice_no = 'true'
      //   }
      // })
      // this.$emit('bind-invoice', order_id)
      this.handelGetOrders();
    },
    doEmitInvoiceCheck() {
      this.handelGetOrders();
    },
    clearCompanyRowCol() {
      this.rowSelected = ''
      this.colSelected = ''
    },
    beforeExpUpload(file) {
      if (!this.rowSelected || !this.colSelected) {
        this.$message.warning('请选择公司名称所在行列')
      }
      const isExcel = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'].includes(file.type)
      const isLt100M = file.size / 1024 / 1024 < 100

      if (!isExcel) {
        this.$message.error('请上传Excel或Csv文件（.xlsx/.xls/.csv）！')
        return false
      }
      if (!isLt100M) {
        this.$message.error('文件大小不能超过100MB！')
        return false
      }

      return true
    },
    async doInvoiceExport(param) {
      const searchStr = this.searchStr.startsWith('&') ? this.searchStr.slice(1) : this.searchStr
      const searchUrlParams = new URLSearchParams(searchStr)
      const searchObj = Object.fromEntries(searchUrlParams.entries())
      const formData = new FormData()
      formData.append('file', param.file)
      formData.append('searchArr',JSON.stringify(searchObj))
      formData.append('row', this.rowSelected)
      formData.append('col', this.colSelected)
      const { data } = await this.$axios.post(`${hyperfHost}qyh/tyc_order/exportWithInvoice`, formData)
      if (data.code === 0) {
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg || '导出失败')
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickCollapseOutSide);
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  mounted() {
    this.handelGetOrders();
    this.handleGetCounts();
    this.ysyGetAdminUserNode_all();
    this.currentTime = this.getCurrentTime();
    document.addEventListener("click", this.handleClickCollapseOutSide);
    window.addEventListener('keydown', this.handleKeyDown);
  },
  watch: {
    ysyAdminUserNode_all(n, o) {
      if (n !== o) {
        if (n.indexOf(84) !== -1) {
          this.hasDecryptPhonePower = true;
        }
      }
    },
  },
};
</script>

<style scoped>
.top_hint {
  height: 0.8rem;
  line-height: 0.8rem;
  background: #ecf4ff;

  span {
    color: #5787ff;
  }
}

.loading-placeholder {
  text-align: center;
  padding: 20px;
}

[v-cloak] {
  display: none;
}

.el-drawer__wrapper>>>.el-drawer {
  overflow-y: auto;
}

.tyc_order .el-drawer__header {
  font-size: 0.36rem;
  font-weight: 400;
  color: #4d84fe;
}

.tyc_order>>>.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 0.5rem;
}

.tyc_order>>>.video {
  background-color: #606266 !important;
  color: #fff !important;
}

.tyc_order>>>.el-timeline-item__node--normal {
  left: 0;
}

.tyc_order {
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
  max-height: 100vh;

  .count-style {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .header-style {
    z-index: 2;
    height: 86px !important;
    padding: 0px !important;
  }

  .main-style {
    z-index: 1;
    padding: 0px !important;
    /* overflow-y: auto; */
  }

  .footer-style {
    text-align: right;

    .el-pagination {
      padding-top: 25px;
    }
  }

  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  }

  .titleText {
    width: 35%;
  }

  .search-item {
    display: flex;
    align-content: flex-start;
    width: 25%;
    margin: 0 0.3rem 0.4rem 0;
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.count {
  padding-left: 0.2rem;
  line-height: 0.56rem;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-10 {
  margin-bottom: 0.2rem;
}

.mb-20 {
  margin-bottom: 0.4rem;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mt-40 {
  margin-top: 0.8rem;
}

.mt-50 {
  margin-top: 1rem;
}

.mb-50 {
  margin-bottom: 1rem;
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;

  .m-label {
    line-height: 0.64rem;
  }

  .el-row {
    margin-bottom: 0.4rem;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }

  .tabs-title {
    color: #409eff;
  }
}

.el-select,
.el-cascader {
  width: 100%;
}

.bottom-btn {
  padding: 0.2rem;
  text-align: right;
}

.tr {
  text-align: right;
}

.tyc_order>>>.el-table__header th {
  color: #333333;
  background-color: #ecf4ff;
}

.dot {
  display: inline-block;
  width: 0.1rem;
  height: 0.1rem;
  border-radius: 50%;
  margin-right: 0.1rem;
  top: 0;
  left: -0.2rem;
  bottom: 0;
  margin: auto;
}

.el-card__body p {
  margin-top: 0.4rem;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse>>>.el-collapse-item__header {
  color: #4c87fc;
  font-weight: bold;
}

.el-collapse>>>.el-collapse-item__arrow {
  color: #4c87fc;
}

.el-date-editor {
  width: 100% !important;
}

.setBadge>>>.el-badge__content.is-fixed {
  top: 0.22rem;
  right: 0.06rem;
}

.el-icon-warning {
  color: rgb(208, 35, 35);
}

.popper__arrow {
  position: absolute;
  top: 0.04rem;
  left: 0.36rem;
  display: block;
  margin-right: 0.06rem;
  border-color: transparent;
  border-style: solid;
  border-width: 0.18rem;
  border-top-width: 0;
  border-bottom-color: #eef0f5;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
}

.ticket>>>.el-form-item__content {
  line-height: 4px;
}

.m-tab {
  border-top: 1px solid #dee2e6;
  border-left: 1px solid #dee2e6;
  margin-bottom: 0.5rem;
}

.m-th {
  height: 42px;
  line-height: 42px;
  padding: 0 5px;
  border-bottom: 1px solid #dee2e6;
  color: #909399;
  background: #fafafa;
}

.m-td {
  height: 42px;
  line-height: 42px;
  padding: 0 5px;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

.icon-class {
  width: 16px;
  margin-bottom: 0.06rem;
  margin-right: 0.1rem;
}

.AIdrawer {
  width: 800px;
}

.AIdrawer .drawer-title {
  background-color: #ecf5ff;
  padding: 10px;
  color: #409EFF;
}

.AIdrawerWrapper {
  width: 800px !important;
  margin-left: auto;
}
</style>

<style module>
.expSelContainer {
  display: flex;
  gap: 8px;
}

.expSelContainer>.selectItem {
  flex: 1;
}

.upStyle {
  float: right;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/tyc_order/TycOrder.vue